(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core-libs/opentelemetry-sdk-trace-web/assets/javascripts/opentelemetry-sdk-trace-web.js') >= 0) return;  svs.modules.push('/components/core-libs/opentelemetry-sdk-trace-web/assets/javascripts/opentelemetry-sdk-trace-web.js');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function() {
return  (function() { 
 	"use strict";
 	var __webpack_require__ = {};
 	!function() {
 		__webpack_require__.g = (function() {
 			if (typeof globalThis === 'object') return globalThis;
 			try {
 				return this || new Function('return this')();
 			} catch (e) {
 				if (typeof window === 'object') return window;
 			}
 		})();
 	}();
var __webpack_exports__ = {};

;
const objectTag = '[object Object]';
const nullTag = '[object Null]';
const undefinedTag = '[object Undefined]';
const funcProto = Function.prototype;
const funcToString = funcProto.toString;
const objectCtorString = funcToString.call(Object);
const getPrototypeOf = Object.getPrototypeOf;
const objectProto = Object.prototype;
const lodash_merge_hasOwnProperty = objectProto.hasOwnProperty;
const symToStringTag = Symbol ? Symbol.toStringTag : undefined;
const nativeObjectToString = objectProto.toString;
function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) !== objectTag) {
        return false;
    }
    const proto = getPrototypeOf(value);
    if (proto === null) {
        return true;
    }
    const Ctor = lodash_merge_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return (typeof Ctor == 'function' &&
        Ctor instanceof Ctor &&
        funcToString.call(Ctor) === objectCtorString);
}
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value)
        ? getRawTag(value)
        : objectToString(value);
}
function getRawTag(value) {
    const isOwn = lodash_merge_hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    let unmasked = false;
    try {
        value[symToStringTag] = undefined;
        unmasked = true;
    }
    catch (e) {
    }
    const result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) {
            value[symToStringTag] = tag;
        }
        else {
            delete value[symToStringTag];
        }
    }
    return result;
}
function objectToString(value) {
    return nativeObjectToString.call(value);
}
;

const MAX_LEVEL = 20;
function merge(...args) {
    let result = args.shift();
    const objects = new WeakMap();
    while (args.length > 0) {
        result = mergeTwoObjects(result, args.shift(), 0, objects);
    }
    return result;
}
function takeValue(value) {
    if (isArray(value)) {
        return value.slice();
    }
    return value;
}
function mergeTwoObjects(one, two, level = 0, objects) {
    let result;
    if (level > MAX_LEVEL) {
        return undefined;
    }
    level++;
    if (isPrimitive(one) || isPrimitive(two) || isFunction(two)) {
        result = takeValue(two);
    }
    else if (isArray(one)) {
        result = one.slice();
        if (isArray(two)) {
            for (let i = 0, j = two.length; i < j; i++) {
                result.push(takeValue(two[i]));
            }
        }
        else if (isObject(two)) {
            const keys = Object.keys(two);
            for (let i = 0, j = keys.length; i < j; i++) {
                const key = keys[i];
                result[key] = takeValue(two[key]);
            }
        }
    }
    else if (isObject(one)) {
        if (isObject(two)) {
            if (!shouldMerge(one, two)) {
                return two;
            }
            result = Object.assign({}, one);
            const keys = Object.keys(two);
            for (let i = 0, j = keys.length; i < j; i++) {
                const key = keys[i];
                const twoValue = two[key];
                if (isPrimitive(twoValue)) {
                    if (typeof twoValue === 'undefined') {
                        delete result[key];
                    }
                    else {
                        result[key] = twoValue;
                    }
                }
                else {
                    const obj1 = result[key];
                    const obj2 = twoValue;
                    if (wasObjectReferenced(one, key, objects) ||
                        wasObjectReferenced(two, key, objects)) {
                        delete result[key];
                    }
                    else {
                        if (isObject(obj1) && isObject(obj2)) {
                            const arr1 = objects.get(obj1) || [];
                            const arr2 = objects.get(obj2) || [];
                            arr1.push({ obj: one, key });
                            arr2.push({ obj: two, key });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        }
        else {
            result = two;
        }
    }
    return result;
}
function wasObjectReferenced(obj, key, objects) {
    const arr = objects.get(obj[key]) || [];
    for (let i = 0, j = arr.length; i < j; i++) {
        const info = arr[i];
        if (info.key === key && info.obj === obj) {
            return true;
        }
    }
    return false;
}
function isArray(value) {
    return Array.isArray(value);
}
function isFunction(value) {
    return typeof value === 'function';
}
function isObject(value) {
    return (!isPrimitive(value) &&
        !isArray(value) &&
        !isFunction(value) &&
        typeof value === 'object');
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        typeof value === 'undefined' ||
        value instanceof Date ||
        value instanceof RegExp ||
        value === null);
}
function shouldMerge(one, two) {
    if (!isPlainObject(one) || !isPlainObject(two)) {
        return false;
    }
    return true;
}
;
var _globalThis = typeof globalThis === 'object'
    ? globalThis
    : typeof self === 'object'
        ? self
        : typeof window === 'object'
            ? window
            : typeof __webpack_require__.g === 'object'
                ? __webpack_require__.g
                : {};
;
var VERSION = '1.9.0';
;

var re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function _makeCompatibilityCheck(ownVersion) {
    var acceptedVersions = new Set([ownVersion]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match(re);
    if (!myVersionMatch) {
        return function () { return false; };
    }
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4],
    };
    if (ownVersionParsed.prerelease != null) {
        return function isExactmatch(globalVersion) {
            return globalVersion === ownVersion;
        };
    }
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) {
            return true;
        }
        if (rejectedVersions.has(globalVersion)) {
            return false;
        }
        var globalVersionMatch = globalVersion.match(re);
        if (!globalVersionMatch) {
            return _reject(globalVersion);
        }
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4],
        };
        if (globalVersionParsed.prerelease != null) {
            return _reject(globalVersion);
        }
        if (ownVersionParsed.major !== globalVersionParsed.major) {
            return _reject(globalVersion);
        }
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor &&
                ownVersionParsed.patch <= globalVersionParsed.patch) {
                return _accept(globalVersion);
            }
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) {
            return _accept(globalVersion);
        }
        return _reject(globalVersion);
    };
}
var isCompatible = _makeCompatibilityCheck(VERSION);
;



var major = VERSION.split('.')[0];
var GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + major);
var _global = _globalThis;
function registerGlobal(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) { allowOverride = false; }
    var api = (_global[GLOBAL_OPENTELEMETRY_API_KEY] = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: VERSION,
    });
    if (!allowOverride && api[type]) {
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== VERSION) {
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + VERSION);
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + VERSION + ".");
    return true;
}
function getGlobal(type) {
    var _a, _b;
    var globalVersion = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !isCompatible(globalVersion)) {
        return;
    }
    return (_b = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + VERSION + ".");
    var api = _global[GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) {
        delete api[type];
    }
}
;
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var DiagComponentLogger =  (function () {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}());

function logProxy(funcName, namespace, args) {
    var logger = getGlobal('diag');
    if (!logger) {
        return;
    }
    args.unshift(namespace);
    return logger[funcName].apply(logger, __spreadArray([], __read(args), false));
}
;
var DiagLogLevel;
(function (DiagLogLevel) {
    DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel || (DiagLogLevel = {}));
;

function createLogLevelDiagLogger(maxLevel, logger) {
    if (maxLevel < DiagLogLevel.NONE) {
        maxLevel = DiagLogLevel.NONE;
    }
    else if (maxLevel > DiagLogLevel.ALL) {
        maxLevel = DiagLogLevel.ALL;
    }
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) {
            return theFunc.bind(logger);
        }
        return function () { };
    }
    return {
        error: _filterFunc('error', DiagLogLevel.ERROR),
        warn: _filterFunc('warn', DiagLogLevel.WARN),
        info: _filterFunc('info', DiagLogLevel.INFO),
        debug: _filterFunc('debug', DiagLogLevel.DEBUG),
        verbose: _filterFunc('verbose', DiagLogLevel.VERBOSE),
    };
}
;
var diag_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var diag_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};




var API_NAME = 'diag';
var DiagAPI =  (function () {
    function DiagAPI() {
        function _logProxy(funcName) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var logger = getGlobal('diag');
                if (!logger)
                    return;
                return logger[funcName].apply(logger, diag_spreadArray([], diag_read(args), false));
            };
        }
        var self = this;
        var setLogger = function (logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) { optionsOrLogLevel = { logLevel: DiagLogLevel.INFO }; }
            if (logger === self) {
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') {
                optionsOrLogLevel = {
                    logLevel: optionsOrLogLevel,
                };
            }
            var oldLogger = getGlobal('diag');
            var newLogger = createLogLevelDiagLogger((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : DiagLogLevel.INFO, logger);
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return registerGlobal('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function () {
            unregisterGlobal(API_NAME, self);
        };
        self.createComponentLogger = function (options) {
            return new DiagComponentLogger(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    DiagAPI.instance = function () {
        if (!this._instance) {
            this._instance = new DiagAPI();
        }
        return this._instance;
    };
    return DiagAPI;
}());

;

var diag = DiagAPI.instance();
;
const version_VERSION = '2.0.0';
;
function createConstMap(values) {
    let res = {};
    const len = values.length;
    for (let lp = 0; lp < len; lp++) {
        const val = values[lp];
        if (val) {
            res[String(val).toUpperCase().replace(/[-.]/g, '_')] = val;
        }
    }
    return res;
}
;

const TMP_CLOUD_PROVIDER = 'cloud.provider';
const TMP_CLOUD_ACCOUNT_ID = 'cloud.account.id';
const TMP_CLOUD_REGION = 'cloud.region';
const TMP_CLOUD_AVAILABILITY_ZONE = 'cloud.availability_zone';
const TMP_CLOUD_PLATFORM = 'cloud.platform';
const TMP_AWS_ECS_CONTAINER_ARN = 'aws.ecs.container.arn';
const TMP_AWS_ECS_CLUSTER_ARN = 'aws.ecs.cluster.arn';
const TMP_AWS_ECS_LAUNCHTYPE = 'aws.ecs.launchtype';
const TMP_AWS_ECS_TASK_ARN = 'aws.ecs.task.arn';
const TMP_AWS_ECS_TASK_FAMILY = 'aws.ecs.task.family';
const TMP_AWS_ECS_TASK_REVISION = 'aws.ecs.task.revision';
const TMP_AWS_EKS_CLUSTER_ARN = 'aws.eks.cluster.arn';
const TMP_AWS_LOG_GROUP_NAMES = 'aws.log.group.names';
const TMP_AWS_LOG_GROUP_ARNS = 'aws.log.group.arns';
const TMP_AWS_LOG_STREAM_NAMES = 'aws.log.stream.names';
const TMP_AWS_LOG_STREAM_ARNS = 'aws.log.stream.arns';
const TMP_CONTAINER_NAME = 'container.name';
const TMP_CONTAINER_ID = 'container.id';
const TMP_CONTAINER_RUNTIME = 'container.runtime';
const TMP_CONTAINER_IMAGE_NAME = 'container.image.name';
const TMP_CONTAINER_IMAGE_TAG = 'container.image.tag';
const TMP_DEPLOYMENT_ENVIRONMENT = 'deployment.environment';
const TMP_DEVICE_ID = 'device.id';
const TMP_DEVICE_MODEL_IDENTIFIER = 'device.model.identifier';
const TMP_DEVICE_MODEL_NAME = 'device.model.name';
const TMP_FAAS_NAME = 'faas.name';
const TMP_FAAS_ID = 'faas.id';
const TMP_FAAS_VERSION = 'faas.version';
const TMP_FAAS_INSTANCE = 'faas.instance';
const TMP_FAAS_MAX_MEMORY = 'faas.max_memory';
const TMP_HOST_ID = 'host.id';
const TMP_HOST_NAME = 'host.name';
const TMP_HOST_TYPE = 'host.type';
const TMP_HOST_ARCH = 'host.arch';
const TMP_HOST_IMAGE_NAME = 'host.image.name';
const TMP_HOST_IMAGE_ID = 'host.image.id';
const TMP_HOST_IMAGE_VERSION = 'host.image.version';
const TMP_K8S_CLUSTER_NAME = 'k8s.cluster.name';
const TMP_K8S_NODE_NAME = 'k8s.node.name';
const TMP_K8S_NODE_UID = 'k8s.node.uid';
const TMP_K8S_NAMESPACE_NAME = 'k8s.namespace.name';
const TMP_K8S_POD_UID = 'k8s.pod.uid';
const TMP_K8S_POD_NAME = 'k8s.pod.name';
const TMP_K8S_CONTAINER_NAME = 'k8s.container.name';
const TMP_K8S_REPLICASET_UID = 'k8s.replicaset.uid';
const TMP_K8S_REPLICASET_NAME = 'k8s.replicaset.name';
const TMP_K8S_DEPLOYMENT_UID = 'k8s.deployment.uid';
const TMP_K8S_DEPLOYMENT_NAME = 'k8s.deployment.name';
const TMP_K8S_STATEFULSET_UID = 'k8s.statefulset.uid';
const TMP_K8S_STATEFULSET_NAME = 'k8s.statefulset.name';
const TMP_K8S_DAEMONSET_UID = 'k8s.daemonset.uid';
const TMP_K8S_DAEMONSET_NAME = 'k8s.daemonset.name';
const TMP_K8S_JOB_UID = 'k8s.job.uid';
const TMP_K8S_JOB_NAME = 'k8s.job.name';
const TMP_K8S_CRONJOB_UID = 'k8s.cronjob.uid';
const TMP_K8S_CRONJOB_NAME = 'k8s.cronjob.name';
const TMP_OS_TYPE = 'os.type';
const TMP_OS_DESCRIPTION = 'os.description';
const TMP_OS_NAME = 'os.name';
const TMP_OS_VERSION = 'os.version';
const TMP_PROCESS_PID = 'process.pid';
const TMP_PROCESS_EXECUTABLE_NAME = 'process.executable.name';
const TMP_PROCESS_EXECUTABLE_PATH = 'process.executable.path';
const TMP_PROCESS_COMMAND = 'process.command';
const TMP_PROCESS_COMMAND_LINE = 'process.command_line';
const TMP_PROCESS_COMMAND_ARGS = 'process.command_args';
const TMP_PROCESS_OWNER = 'process.owner';
const TMP_PROCESS_RUNTIME_NAME = 'process.runtime.name';
const TMP_PROCESS_RUNTIME_VERSION = 'process.runtime.version';
const TMP_PROCESS_RUNTIME_DESCRIPTION = 'process.runtime.description';
const TMP_SERVICE_NAME = 'service.name';
const TMP_SERVICE_NAMESPACE = 'service.namespace';
const TMP_SERVICE_INSTANCE_ID = 'service.instance.id';
const TMP_SERVICE_VERSION = 'service.version';
const TMP_TELEMETRY_SDK_NAME = 'telemetry.sdk.name';
const TMP_TELEMETRY_SDK_LANGUAGE = 'telemetry.sdk.language';
const TMP_TELEMETRY_SDK_VERSION = 'telemetry.sdk.version';
const TMP_TELEMETRY_AUTO_VERSION = 'telemetry.auto.version';
const TMP_WEBENGINE_NAME = 'webengine.name';
const TMP_WEBENGINE_VERSION = 'webengine.version';
const TMP_WEBENGINE_DESCRIPTION = 'webengine.description';
const SEMRESATTRS_CLOUD_PROVIDER = ( null && (TMP_CLOUD_PROVIDER));
const SEMRESATTRS_CLOUD_ACCOUNT_ID = ( null && (TMP_CLOUD_ACCOUNT_ID));
const SEMRESATTRS_CLOUD_REGION = ( null && (TMP_CLOUD_REGION));
const SEMRESATTRS_CLOUD_AVAILABILITY_ZONE = ( null && (TMP_CLOUD_AVAILABILITY_ZONE));
const SEMRESATTRS_CLOUD_PLATFORM = ( null && (TMP_CLOUD_PLATFORM));
const SEMRESATTRS_AWS_ECS_CONTAINER_ARN = ( null && (TMP_AWS_ECS_CONTAINER_ARN));
const SEMRESATTRS_AWS_ECS_CLUSTER_ARN = ( null && (TMP_AWS_ECS_CLUSTER_ARN));
const SEMRESATTRS_AWS_ECS_LAUNCHTYPE = ( null && (TMP_AWS_ECS_LAUNCHTYPE));
const SEMRESATTRS_AWS_ECS_TASK_ARN = ( null && (TMP_AWS_ECS_TASK_ARN));
const SEMRESATTRS_AWS_ECS_TASK_FAMILY = ( null && (TMP_AWS_ECS_TASK_FAMILY));
const SEMRESATTRS_AWS_ECS_TASK_REVISION = ( null && (TMP_AWS_ECS_TASK_REVISION));
const SEMRESATTRS_AWS_EKS_CLUSTER_ARN = ( null && (TMP_AWS_EKS_CLUSTER_ARN));
const SEMRESATTRS_AWS_LOG_GROUP_NAMES = ( null && (TMP_AWS_LOG_GROUP_NAMES));
const SEMRESATTRS_AWS_LOG_GROUP_ARNS = ( null && (TMP_AWS_LOG_GROUP_ARNS));
const SEMRESATTRS_AWS_LOG_STREAM_NAMES = ( null && (TMP_AWS_LOG_STREAM_NAMES));
const SEMRESATTRS_AWS_LOG_STREAM_ARNS = ( null && (TMP_AWS_LOG_STREAM_ARNS));
const SEMRESATTRS_CONTAINER_NAME = ( null && (TMP_CONTAINER_NAME));
const SEMRESATTRS_CONTAINER_ID = ( null && (TMP_CONTAINER_ID));
const SEMRESATTRS_CONTAINER_RUNTIME = ( null && (TMP_CONTAINER_RUNTIME));
const SEMRESATTRS_CONTAINER_IMAGE_NAME = ( null && (TMP_CONTAINER_IMAGE_NAME));
const SEMRESATTRS_CONTAINER_IMAGE_TAG = ( null && (TMP_CONTAINER_IMAGE_TAG));
const SEMRESATTRS_DEPLOYMENT_ENVIRONMENT = ( null && (TMP_DEPLOYMENT_ENVIRONMENT));
const SEMRESATTRS_DEVICE_ID = ( null && (TMP_DEVICE_ID));
const SEMRESATTRS_DEVICE_MODEL_IDENTIFIER = ( null && (TMP_DEVICE_MODEL_IDENTIFIER));
const SEMRESATTRS_DEVICE_MODEL_NAME = ( null && (TMP_DEVICE_MODEL_NAME));
const SEMRESATTRS_FAAS_NAME = ( null && (TMP_FAAS_NAME));
const SEMRESATTRS_FAAS_ID = ( null && (TMP_FAAS_ID));
const SEMRESATTRS_FAAS_VERSION = ( null && (TMP_FAAS_VERSION));
const SEMRESATTRS_FAAS_INSTANCE = ( null && (TMP_FAAS_INSTANCE));
const SEMRESATTRS_FAAS_MAX_MEMORY = ( null && (TMP_FAAS_MAX_MEMORY));
const SEMRESATTRS_HOST_ID = ( null && (TMP_HOST_ID));
const SEMRESATTRS_HOST_NAME = ( null && (TMP_HOST_NAME));
const SEMRESATTRS_HOST_TYPE = ( null && (TMP_HOST_TYPE));
const SEMRESATTRS_HOST_ARCH = ( null && (TMP_HOST_ARCH));
const SEMRESATTRS_HOST_IMAGE_NAME = ( null && (TMP_HOST_IMAGE_NAME));
const SEMRESATTRS_HOST_IMAGE_ID = ( null && (TMP_HOST_IMAGE_ID));
const SEMRESATTRS_HOST_IMAGE_VERSION = ( null && (TMP_HOST_IMAGE_VERSION));
const SEMRESATTRS_K8S_CLUSTER_NAME = ( null && (TMP_K8S_CLUSTER_NAME));
const SEMRESATTRS_K8S_NODE_NAME = ( null && (TMP_K8S_NODE_NAME));
const SEMRESATTRS_K8S_NODE_UID = ( null && (TMP_K8S_NODE_UID));
const SEMRESATTRS_K8S_NAMESPACE_NAME = ( null && (TMP_K8S_NAMESPACE_NAME));
const SEMRESATTRS_K8S_POD_UID = ( null && (TMP_K8S_POD_UID));
const SEMRESATTRS_K8S_POD_NAME = ( null && (TMP_K8S_POD_NAME));
const SEMRESATTRS_K8S_CONTAINER_NAME = ( null && (TMP_K8S_CONTAINER_NAME));
const SEMRESATTRS_K8S_REPLICASET_UID = ( null && (TMP_K8S_REPLICASET_UID));
const SEMRESATTRS_K8S_REPLICASET_NAME = ( null && (TMP_K8S_REPLICASET_NAME));
const SEMRESATTRS_K8S_DEPLOYMENT_UID = ( null && (TMP_K8S_DEPLOYMENT_UID));
const SEMRESATTRS_K8S_DEPLOYMENT_NAME = ( null && (TMP_K8S_DEPLOYMENT_NAME));
const SEMRESATTRS_K8S_STATEFULSET_UID = ( null && (TMP_K8S_STATEFULSET_UID));
const SEMRESATTRS_K8S_STATEFULSET_NAME = ( null && (TMP_K8S_STATEFULSET_NAME));
const SEMRESATTRS_K8S_DAEMONSET_UID = ( null && (TMP_K8S_DAEMONSET_UID));
const SEMRESATTRS_K8S_DAEMONSET_NAME = ( null && (TMP_K8S_DAEMONSET_NAME));
const SEMRESATTRS_K8S_JOB_UID = ( null && (TMP_K8S_JOB_UID));
const SEMRESATTRS_K8S_JOB_NAME = ( null && (TMP_K8S_JOB_NAME));
const SEMRESATTRS_K8S_CRONJOB_UID = ( null && (TMP_K8S_CRONJOB_UID));
const SEMRESATTRS_K8S_CRONJOB_NAME = ( null && (TMP_K8S_CRONJOB_NAME));
const SEMRESATTRS_OS_TYPE = ( null && (TMP_OS_TYPE));
const SEMRESATTRS_OS_DESCRIPTION = ( null && (TMP_OS_DESCRIPTION));
const SEMRESATTRS_OS_NAME = ( null && (TMP_OS_NAME));
const SEMRESATTRS_OS_VERSION = ( null && (TMP_OS_VERSION));
const SEMRESATTRS_PROCESS_PID = ( null && (TMP_PROCESS_PID));
const SEMRESATTRS_PROCESS_EXECUTABLE_NAME = ( null && (TMP_PROCESS_EXECUTABLE_NAME));
const SEMRESATTRS_PROCESS_EXECUTABLE_PATH = ( null && (TMP_PROCESS_EXECUTABLE_PATH));
const SEMRESATTRS_PROCESS_COMMAND = ( null && (TMP_PROCESS_COMMAND));
const SEMRESATTRS_PROCESS_COMMAND_LINE = ( null && (TMP_PROCESS_COMMAND_LINE));
const SEMRESATTRS_PROCESS_COMMAND_ARGS = ( null && (TMP_PROCESS_COMMAND_ARGS));
const SEMRESATTRS_PROCESS_OWNER = ( null && (TMP_PROCESS_OWNER));
const SEMRESATTRS_PROCESS_RUNTIME_NAME = TMP_PROCESS_RUNTIME_NAME;
const SEMRESATTRS_PROCESS_RUNTIME_VERSION = ( null && (TMP_PROCESS_RUNTIME_VERSION));
const SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION = ( null && (TMP_PROCESS_RUNTIME_DESCRIPTION));
const SEMRESATTRS_SERVICE_NAME = ( null && (TMP_SERVICE_NAME));
const SEMRESATTRS_SERVICE_NAMESPACE = ( null && (TMP_SERVICE_NAMESPACE));
const SEMRESATTRS_SERVICE_INSTANCE_ID = ( null && (TMP_SERVICE_INSTANCE_ID));
const SEMRESATTRS_SERVICE_VERSION = ( null && (TMP_SERVICE_VERSION));
const SEMRESATTRS_TELEMETRY_SDK_NAME = TMP_TELEMETRY_SDK_NAME;
const SEMRESATTRS_TELEMETRY_SDK_LANGUAGE = TMP_TELEMETRY_SDK_LANGUAGE;
const SEMRESATTRS_TELEMETRY_SDK_VERSION = TMP_TELEMETRY_SDK_VERSION;
const SEMRESATTRS_TELEMETRY_AUTO_VERSION = ( null && (TMP_TELEMETRY_AUTO_VERSION));
const SEMRESATTRS_WEBENGINE_NAME = ( null && (TMP_WEBENGINE_NAME));
const SEMRESATTRS_WEBENGINE_VERSION = ( null && (TMP_WEBENGINE_VERSION));
const SEMRESATTRS_WEBENGINE_DESCRIPTION = ( null && (TMP_WEBENGINE_DESCRIPTION));
const SemanticResourceAttributes = 
 createConstMap([
    TMP_CLOUD_PROVIDER,
    TMP_CLOUD_ACCOUNT_ID,
    TMP_CLOUD_REGION,
    TMP_CLOUD_AVAILABILITY_ZONE,
    TMP_CLOUD_PLATFORM,
    TMP_AWS_ECS_CONTAINER_ARN,
    TMP_AWS_ECS_CLUSTER_ARN,
    TMP_AWS_ECS_LAUNCHTYPE,
    TMP_AWS_ECS_TASK_ARN,
    TMP_AWS_ECS_TASK_FAMILY,
    TMP_AWS_ECS_TASK_REVISION,
    TMP_AWS_EKS_CLUSTER_ARN,
    TMP_AWS_LOG_GROUP_NAMES,
    TMP_AWS_LOG_GROUP_ARNS,
    TMP_AWS_LOG_STREAM_NAMES,
    TMP_AWS_LOG_STREAM_ARNS,
    TMP_CONTAINER_NAME,
    TMP_CONTAINER_ID,
    TMP_CONTAINER_RUNTIME,
    TMP_CONTAINER_IMAGE_NAME,
    TMP_CONTAINER_IMAGE_TAG,
    TMP_DEPLOYMENT_ENVIRONMENT,
    TMP_DEVICE_ID,
    TMP_DEVICE_MODEL_IDENTIFIER,
    TMP_DEVICE_MODEL_NAME,
    TMP_FAAS_NAME,
    TMP_FAAS_ID,
    TMP_FAAS_VERSION,
    TMP_FAAS_INSTANCE,
    TMP_FAAS_MAX_MEMORY,
    TMP_HOST_ID,
    TMP_HOST_NAME,
    TMP_HOST_TYPE,
    TMP_HOST_ARCH,
    TMP_HOST_IMAGE_NAME,
    TMP_HOST_IMAGE_ID,
    TMP_HOST_IMAGE_VERSION,
    TMP_K8S_CLUSTER_NAME,
    TMP_K8S_NODE_NAME,
    TMP_K8S_NODE_UID,
    TMP_K8S_NAMESPACE_NAME,
    TMP_K8S_POD_UID,
    TMP_K8S_POD_NAME,
    TMP_K8S_CONTAINER_NAME,
    TMP_K8S_REPLICASET_UID,
    TMP_K8S_REPLICASET_NAME,
    TMP_K8S_DEPLOYMENT_UID,
    TMP_K8S_DEPLOYMENT_NAME,
    TMP_K8S_STATEFULSET_UID,
    TMP_K8S_STATEFULSET_NAME,
    TMP_K8S_DAEMONSET_UID,
    TMP_K8S_DAEMONSET_NAME,
    TMP_K8S_JOB_UID,
    TMP_K8S_JOB_NAME,
    TMP_K8S_CRONJOB_UID,
    TMP_K8S_CRONJOB_NAME,
    TMP_OS_TYPE,
    TMP_OS_DESCRIPTION,
    TMP_OS_NAME,
    TMP_OS_VERSION,
    TMP_PROCESS_PID,
    TMP_PROCESS_EXECUTABLE_NAME,
    TMP_PROCESS_EXECUTABLE_PATH,
    TMP_PROCESS_COMMAND,
    TMP_PROCESS_COMMAND_LINE,
    TMP_PROCESS_COMMAND_ARGS,
    TMP_PROCESS_OWNER,
    TMP_PROCESS_RUNTIME_NAME,
    TMP_PROCESS_RUNTIME_VERSION,
    TMP_PROCESS_RUNTIME_DESCRIPTION,
    TMP_SERVICE_NAME,
    TMP_SERVICE_NAMESPACE,
    TMP_SERVICE_INSTANCE_ID,
    TMP_SERVICE_VERSION,
    TMP_TELEMETRY_SDK_NAME,
    TMP_TELEMETRY_SDK_LANGUAGE,
    TMP_TELEMETRY_SDK_VERSION,
    TMP_TELEMETRY_AUTO_VERSION,
    TMP_WEBENGINE_NAME,
    TMP_WEBENGINE_VERSION,
    TMP_WEBENGINE_DESCRIPTION,
]);
const TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD = 'alibaba_cloud';
const TMP_CLOUDPROVIDERVALUES_AWS = 'aws';
const TMP_CLOUDPROVIDERVALUES_AZURE = 'azure';
const TMP_CLOUDPROVIDERVALUES_GCP = 'gcp';
const CLOUDPROVIDERVALUES_ALIBABA_CLOUD = ( null && (TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD));
const CLOUDPROVIDERVALUES_AWS = ( null && (TMP_CLOUDPROVIDERVALUES_AWS));
const CLOUDPROVIDERVALUES_AZURE = ( null && (TMP_CLOUDPROVIDERVALUES_AZURE));
const CLOUDPROVIDERVALUES_GCP = ( null && (TMP_CLOUDPROVIDERVALUES_GCP));
const CloudProviderValues = 
 createConstMap([
    TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD,
    TMP_CLOUDPROVIDERVALUES_AWS,
    TMP_CLOUDPROVIDERVALUES_AZURE,
    TMP_CLOUDPROVIDERVALUES_GCP,
]);
const TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = 'alibaba_cloud_ecs';
const TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = 'alibaba_cloud_fc';
const TMP_CLOUDPLATFORMVALUES_AWS_EC2 = 'aws_ec2';
const TMP_CLOUDPLATFORMVALUES_AWS_ECS = 'aws_ecs';
const TMP_CLOUDPLATFORMVALUES_AWS_EKS = 'aws_eks';
const TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA = 'aws_lambda';
const TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = 'aws_elastic_beanstalk';
const TMP_CLOUDPLATFORMVALUES_AZURE_VM = 'azure_vm';
const TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = 'azure_container_instances';
const TMP_CLOUDPLATFORMVALUES_AZURE_AKS = 'azure_aks';
const TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = 'azure_functions';
const TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = 'azure_app_service';
const TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = 'gcp_compute_engine';
const TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = 'gcp_cloud_run';
const TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = 'gcp_kubernetes_engine';
const TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = 'gcp_cloud_functions';
const TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE = 'gcp_app_engine';
const CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = ( null && (TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS));
const CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = ( null && (TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC));
const CLOUDPLATFORMVALUES_AWS_EC2 = ( null && (TMP_CLOUDPLATFORMVALUES_AWS_EC2));
const CLOUDPLATFORMVALUES_AWS_ECS = ( null && (TMP_CLOUDPLATFORMVALUES_AWS_ECS));
const CLOUDPLATFORMVALUES_AWS_EKS = ( null && (TMP_CLOUDPLATFORMVALUES_AWS_EKS));
const CLOUDPLATFORMVALUES_AWS_LAMBDA = ( null && (TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA));
const CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = ( null && (TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK));
const CLOUDPLATFORMVALUES_AZURE_VM = ( null && (TMP_CLOUDPLATFORMVALUES_AZURE_VM));
const CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = ( null && (TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES));
const CLOUDPLATFORMVALUES_AZURE_AKS = ( null && (TMP_CLOUDPLATFORMVALUES_AZURE_AKS));
const CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = ( null && (TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS));
const CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = ( null && (TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE));
const CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = ( null && (TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE));
const CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = ( null && (TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN));
const CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = ( null && (TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE));
const CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = ( null && (TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS));
const CLOUDPLATFORMVALUES_GCP_APP_ENGINE = ( null && (TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE));
const CloudPlatformValues = 
 createConstMap([
    TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS,
    TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC,
    TMP_CLOUDPLATFORMVALUES_AWS_EC2,
    TMP_CLOUDPLATFORMVALUES_AWS_ECS,
    TMP_CLOUDPLATFORMVALUES_AWS_EKS,
    TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA,
    TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK,
    TMP_CLOUDPLATFORMVALUES_AZURE_VM,
    TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES,
    TMP_CLOUDPLATFORMVALUES_AZURE_AKS,
    TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS,
    TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE,
    TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE,
    TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN,
    TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE,
    TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS,
    TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE,
]);
const TMP_AWSECSLAUNCHTYPEVALUES_EC2 = 'ec2';
const TMP_AWSECSLAUNCHTYPEVALUES_FARGATE = 'fargate';
const AWSECSLAUNCHTYPEVALUES_EC2 = ( null && (TMP_AWSECSLAUNCHTYPEVALUES_EC2));
const AWSECSLAUNCHTYPEVALUES_FARGATE = ( null && (TMP_AWSECSLAUNCHTYPEVALUES_FARGATE));
const AwsEcsLaunchtypeValues = 
 createConstMap([
    TMP_AWSECSLAUNCHTYPEVALUES_EC2,
    TMP_AWSECSLAUNCHTYPEVALUES_FARGATE,
]);
const TMP_HOSTARCHVALUES_AMD64 = 'amd64';
const TMP_HOSTARCHVALUES_ARM32 = 'arm32';
const TMP_HOSTARCHVALUES_ARM64 = 'arm64';
const TMP_HOSTARCHVALUES_IA64 = 'ia64';
const TMP_HOSTARCHVALUES_PPC32 = 'ppc32';
const TMP_HOSTARCHVALUES_PPC64 = 'ppc64';
const TMP_HOSTARCHVALUES_X86 = 'x86';
const HOSTARCHVALUES_AMD64 = ( null && (TMP_HOSTARCHVALUES_AMD64));
const HOSTARCHVALUES_ARM32 = ( null && (TMP_HOSTARCHVALUES_ARM32));
const HOSTARCHVALUES_ARM64 = ( null && (TMP_HOSTARCHVALUES_ARM64));
const HOSTARCHVALUES_IA64 = ( null && (TMP_HOSTARCHVALUES_IA64));
const HOSTARCHVALUES_PPC32 = ( null && (TMP_HOSTARCHVALUES_PPC32));
const HOSTARCHVALUES_PPC64 = ( null && (TMP_HOSTARCHVALUES_PPC64));
const HOSTARCHVALUES_X86 = ( null && (TMP_HOSTARCHVALUES_X86));
const HostArchValues = 
 createConstMap([
    TMP_HOSTARCHVALUES_AMD64,
    TMP_HOSTARCHVALUES_ARM32,
    TMP_HOSTARCHVALUES_ARM64,
    TMP_HOSTARCHVALUES_IA64,
    TMP_HOSTARCHVALUES_PPC32,
    TMP_HOSTARCHVALUES_PPC64,
    TMP_HOSTARCHVALUES_X86,
]);
const TMP_OSTYPEVALUES_WINDOWS = 'windows';
const TMP_OSTYPEVALUES_LINUX = 'linux';
const TMP_OSTYPEVALUES_DARWIN = 'darwin';
const TMP_OSTYPEVALUES_FREEBSD = 'freebsd';
const TMP_OSTYPEVALUES_NETBSD = 'netbsd';
const TMP_OSTYPEVALUES_OPENBSD = 'openbsd';
const TMP_OSTYPEVALUES_DRAGONFLYBSD = 'dragonflybsd';
const TMP_OSTYPEVALUES_HPUX = 'hpux';
const TMP_OSTYPEVALUES_AIX = 'aix';
const TMP_OSTYPEVALUES_SOLARIS = 'solaris';
const TMP_OSTYPEVALUES_Z_OS = 'z_os';
const OSTYPEVALUES_WINDOWS = ( null && (TMP_OSTYPEVALUES_WINDOWS));
const OSTYPEVALUES_LINUX = ( null && (TMP_OSTYPEVALUES_LINUX));
const OSTYPEVALUES_DARWIN = ( null && (TMP_OSTYPEVALUES_DARWIN));
const OSTYPEVALUES_FREEBSD = ( null && (TMP_OSTYPEVALUES_FREEBSD));
const OSTYPEVALUES_NETBSD = ( null && (TMP_OSTYPEVALUES_NETBSD));
const OSTYPEVALUES_OPENBSD = ( null && (TMP_OSTYPEVALUES_OPENBSD));
const OSTYPEVALUES_DRAGONFLYBSD = ( null && (TMP_OSTYPEVALUES_DRAGONFLYBSD));
const OSTYPEVALUES_HPUX = ( null && (TMP_OSTYPEVALUES_HPUX));
const OSTYPEVALUES_AIX = ( null && (TMP_OSTYPEVALUES_AIX));
const OSTYPEVALUES_SOLARIS = ( null && (TMP_OSTYPEVALUES_SOLARIS));
const OSTYPEVALUES_Z_OS = ( null && (TMP_OSTYPEVALUES_Z_OS));
const OsTypeValues = 
 createConstMap([
    TMP_OSTYPEVALUES_WINDOWS,
    TMP_OSTYPEVALUES_LINUX,
    TMP_OSTYPEVALUES_DARWIN,
    TMP_OSTYPEVALUES_FREEBSD,
    TMP_OSTYPEVALUES_NETBSD,
    TMP_OSTYPEVALUES_OPENBSD,
    TMP_OSTYPEVALUES_DRAGONFLYBSD,
    TMP_OSTYPEVALUES_HPUX,
    TMP_OSTYPEVALUES_AIX,
    TMP_OSTYPEVALUES_SOLARIS,
    TMP_OSTYPEVALUES_Z_OS,
]);
const TMP_TELEMETRYSDKLANGUAGEVALUES_CPP = 'cpp';
const TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET = 'dotnet';
const TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG = 'erlang';
const TMP_TELEMETRYSDKLANGUAGEVALUES_GO = 'go';
const TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA = 'java';
const TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS = 'nodejs';
const TMP_TELEMETRYSDKLANGUAGEVALUES_PHP = 'php';
const TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON = 'python';
const TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY = 'ruby';
const TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS = 'webjs';
const TELEMETRYSDKLANGUAGEVALUES_CPP = ( null && (TMP_TELEMETRYSDKLANGUAGEVALUES_CPP));
const TELEMETRYSDKLANGUAGEVALUES_DOTNET = ( null && (TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET));
const TELEMETRYSDKLANGUAGEVALUES_ERLANG = ( null && (TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG));
const TELEMETRYSDKLANGUAGEVALUES_GO = ( null && (TMP_TELEMETRYSDKLANGUAGEVALUES_GO));
const TELEMETRYSDKLANGUAGEVALUES_JAVA = ( null && (TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA));
const TELEMETRYSDKLANGUAGEVALUES_NODEJS = ( null && (TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS));
const TELEMETRYSDKLANGUAGEVALUES_PHP = ( null && (TMP_TELEMETRYSDKLANGUAGEVALUES_PHP));
const TELEMETRYSDKLANGUAGEVALUES_PYTHON = ( null && (TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON));
const TELEMETRYSDKLANGUAGEVALUES_RUBY = ( null && (TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY));
const TELEMETRYSDKLANGUAGEVALUES_WEBJS = TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS;
const TelemetrySdkLanguageValues = 
 createConstMap([
    TMP_TELEMETRYSDKLANGUAGEVALUES_CPP,
    TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET,
    TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG,
    TMP_TELEMETRYSDKLANGUAGEVALUES_GO,
    TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA,
    TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS,
    TMP_TELEMETRYSDKLANGUAGEVALUES_PHP,
    TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON,
    TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY,
    TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS,
]);
;


const SDK_INFO = {
    [SEMRESATTRS_TELEMETRY_SDK_NAME]: 'opentelemetry',
    [SEMRESATTRS_PROCESS_RUNTIME_NAME]: 'browser',
    [SEMRESATTRS_TELEMETRY_SDK_LANGUAGE]: TELEMETRYSDKLANGUAGEVALUES_WEBJS,
    [SEMRESATTRS_TELEMETRY_SDK_VERSION]: version_VERSION,
};
;
const ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT = 'aspnetcore.diagnostics.exception.result';
const ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_ABORTED = "aborted";
const ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_HANDLED = "handled";
const ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_SKIPPED = "skipped";
const ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_UNHANDLED = "unhandled";
const ATTR_ASPNETCORE_DIAGNOSTICS_HANDLER_TYPE = 'aspnetcore.diagnostics.handler.type';
const ATTR_ASPNETCORE_RATE_LIMITING_POLICY = 'aspnetcore.rate_limiting.policy';
const ATTR_ASPNETCORE_RATE_LIMITING_RESULT = 'aspnetcore.rate_limiting.result';
const ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ACQUIRED = "acquired";
const ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ENDPOINT_LIMITER = "endpoint_limiter";
const ASPNETCORE_RATE_LIMITING_RESULT_VALUE_GLOBAL_LIMITER = "global_limiter";
const ASPNETCORE_RATE_LIMITING_RESULT_VALUE_REQUEST_CANCELED = "request_canceled";
const ATTR_ASPNETCORE_REQUEST_IS_UNHANDLED = 'aspnetcore.request.is_unhandled';
const ATTR_ASPNETCORE_ROUTING_IS_FALLBACK = 'aspnetcore.routing.is_fallback';
const ATTR_ASPNETCORE_ROUTING_MATCH_STATUS = 'aspnetcore.routing.match_status';
const ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_FAILURE = "failure";
const ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_SUCCESS = "success";
const ATTR_CLIENT_ADDRESS = 'client.address';
const ATTR_CLIENT_PORT = 'client.port';
const ATTR_CODE_COLUMN_NUMBER = 'code.column.number';
const ATTR_CODE_FILE_PATH = 'code.file.path';
const ATTR_CODE_FUNCTION_NAME = 'code.function.name';
const ATTR_CODE_LINE_NUMBER = 'code.line.number';
const ATTR_CODE_STACKTRACE = 'code.stacktrace';
const ATTR_DB_COLLECTION_NAME = 'db.collection.name';
const ATTR_DB_NAMESPACE = 'db.namespace';
const ATTR_DB_OPERATION_BATCH_SIZE = 'db.operation.batch.size';
const ATTR_DB_OPERATION_NAME = 'db.operation.name';
const ATTR_DB_QUERY_SUMMARY = 'db.query.summary';
const ATTR_DB_QUERY_TEXT = 'db.query.text';
const ATTR_DB_RESPONSE_STATUS_CODE = 'db.response.status_code';
const ATTR_DB_STORED_PROCEDURE_NAME = 'db.stored_procedure.name';
const ATTR_DB_SYSTEM_NAME = 'db.system.name';
const DB_SYSTEM_NAME_VALUE_ACTIAN_INGRES = "actian.ingres";
const DB_SYSTEM_NAME_VALUE_AWS_DYNAMODB = "aws.dynamodb";
const DB_SYSTEM_NAME_VALUE_AWS_REDSHIFT = "aws.redshift";
const DB_SYSTEM_NAME_VALUE_AZURE_COSMOSDB = "azure.cosmosdb";
const DB_SYSTEM_NAME_VALUE_CASSANDRA = "cassandra";
const DB_SYSTEM_NAME_VALUE_CLICKHOUSE = "clickhouse";
const DB_SYSTEM_NAME_VALUE_COCKROACHDB = "cockroachdb";
const DB_SYSTEM_NAME_VALUE_COUCHBASE = "couchbase";
const DB_SYSTEM_NAME_VALUE_COUCHDB = "couchdb";
const DB_SYSTEM_NAME_VALUE_DERBY = "derby";
const DB_SYSTEM_NAME_VALUE_ELASTICSEARCH = "elasticsearch";
const DB_SYSTEM_NAME_VALUE_FIREBIRDSQL = "firebirdsql";
const DB_SYSTEM_NAME_VALUE_GCP_SPANNER = "gcp.spanner";
const DB_SYSTEM_NAME_VALUE_GEODE = "geode";
const DB_SYSTEM_NAME_VALUE_H2DATABASE = "h2database";
const DB_SYSTEM_NAME_VALUE_HBASE = "hbase";
const DB_SYSTEM_NAME_VALUE_HIVE = "hive";
const DB_SYSTEM_NAME_VALUE_HSQLDB = "hsqldb";
const DB_SYSTEM_NAME_VALUE_IBM_DB2 = "ibm.db2";
const DB_SYSTEM_NAME_VALUE_IBM_INFORMIX = "ibm.informix";
const DB_SYSTEM_NAME_VALUE_IBM_NETEZZA = "ibm.netezza";
const DB_SYSTEM_NAME_VALUE_INFLUXDB = "influxdb";
const DB_SYSTEM_NAME_VALUE_INSTANTDB = "instantdb";
const DB_SYSTEM_NAME_VALUE_INTERSYSTEMS_CACHE = "intersystems.cache";
const DB_SYSTEM_NAME_VALUE_MARIADB = "mariadb";
const DB_SYSTEM_NAME_VALUE_MEMCACHED = "memcached";
const DB_SYSTEM_NAME_VALUE_MICROSOFT_SQL_SERVER = "microsoft.sql_server";
const DB_SYSTEM_NAME_VALUE_MONGODB = "mongodb";
const DB_SYSTEM_NAME_VALUE_MYSQL = "mysql";
const DB_SYSTEM_NAME_VALUE_NEO4J = "neo4j";
const DB_SYSTEM_NAME_VALUE_OPENSEARCH = "opensearch";
const DB_SYSTEM_NAME_VALUE_ORACLE_DB = "oracle.db";
const DB_SYSTEM_NAME_VALUE_OTHER_SQL = "other_sql";
const DB_SYSTEM_NAME_VALUE_POSTGRESQL = "postgresql";
const DB_SYSTEM_NAME_VALUE_REDIS = "redis";
const DB_SYSTEM_NAME_VALUE_SAP_HANA = "sap.hana";
const DB_SYSTEM_NAME_VALUE_SAP_MAXDB = "sap.maxdb";
const DB_SYSTEM_NAME_VALUE_SOFTWAREAG_ADABAS = "softwareag.adabas";
const DB_SYSTEM_NAME_VALUE_SQLITE = "sqlite";
const DB_SYSTEM_NAME_VALUE_TERADATA = "teradata";
const DB_SYSTEM_NAME_VALUE_TRINO = "trino";
const ATTR_DOTNET_GC_HEAP_GENERATION = 'dotnet.gc.heap.generation';
const DOTNET_GC_HEAP_GENERATION_VALUE_GEN0 = "gen0";
const DOTNET_GC_HEAP_GENERATION_VALUE_GEN1 = "gen1";
const DOTNET_GC_HEAP_GENERATION_VALUE_GEN2 = "gen2";
const DOTNET_GC_HEAP_GENERATION_VALUE_LOH = "loh";
const DOTNET_GC_HEAP_GENERATION_VALUE_POH = "poh";
const ATTR_ERROR_TYPE = 'error.type';
const ERROR_TYPE_VALUE_OTHER = "_OTHER";
const ATTR_EXCEPTION_ESCAPED = 'exception.escaped';
const ATTR_EXCEPTION_MESSAGE = 'exception.message';
const ATTR_EXCEPTION_STACKTRACE = 'exception.stacktrace';
const ATTR_EXCEPTION_TYPE = 'exception.type';
const ATTR_HTTP_REQUEST_HEADER = (key) => `http.request.header.${key}`;
const ATTR_HTTP_REQUEST_METHOD = 'http.request.method';
const HTTP_REQUEST_METHOD_VALUE_OTHER = "_OTHER";
const HTTP_REQUEST_METHOD_VALUE_CONNECT = "CONNECT";
const HTTP_REQUEST_METHOD_VALUE_DELETE = "DELETE";
const HTTP_REQUEST_METHOD_VALUE_GET = "GET";
const HTTP_REQUEST_METHOD_VALUE_HEAD = "HEAD";
const HTTP_REQUEST_METHOD_VALUE_OPTIONS = "OPTIONS";
const HTTP_REQUEST_METHOD_VALUE_PATCH = "PATCH";
const HTTP_REQUEST_METHOD_VALUE_POST = "POST";
const HTTP_REQUEST_METHOD_VALUE_PUT = "PUT";
const HTTP_REQUEST_METHOD_VALUE_TRACE = "TRACE";
const ATTR_HTTP_REQUEST_METHOD_ORIGINAL = 'http.request.method_original';
const ATTR_HTTP_REQUEST_RESEND_COUNT = 'http.request.resend_count';
const ATTR_HTTP_RESPONSE_HEADER = (key) => `http.response.header.${key}`;
const ATTR_HTTP_RESPONSE_STATUS_CODE = 'http.response.status_code';
const ATTR_HTTP_ROUTE = 'http.route';
const ATTR_JVM_GC_ACTION = 'jvm.gc.action';
const ATTR_JVM_GC_NAME = 'jvm.gc.name';
const ATTR_JVM_MEMORY_POOL_NAME = 'jvm.memory.pool.name';
const ATTR_JVM_MEMORY_TYPE = 'jvm.memory.type';
const JVM_MEMORY_TYPE_VALUE_HEAP = "heap";
const JVM_MEMORY_TYPE_VALUE_NON_HEAP = "non_heap";
const ATTR_JVM_THREAD_DAEMON = 'jvm.thread.daemon';
const ATTR_JVM_THREAD_STATE = 'jvm.thread.state';
const JVM_THREAD_STATE_VALUE_BLOCKED = "blocked";
const JVM_THREAD_STATE_VALUE_NEW = "new";
const JVM_THREAD_STATE_VALUE_RUNNABLE = "runnable";
const JVM_THREAD_STATE_VALUE_TERMINATED = "terminated";
const JVM_THREAD_STATE_VALUE_TIMED_WAITING = "timed_waiting";
const JVM_THREAD_STATE_VALUE_WAITING = "waiting";
const ATTR_NETWORK_LOCAL_ADDRESS = 'network.local.address';
const ATTR_NETWORK_LOCAL_PORT = 'network.local.port';
const ATTR_NETWORK_PEER_ADDRESS = 'network.peer.address';
const ATTR_NETWORK_PEER_PORT = 'network.peer.port';
const ATTR_NETWORK_PROTOCOL_NAME = 'network.protocol.name';
const ATTR_NETWORK_PROTOCOL_VERSION = 'network.protocol.version';
const ATTR_NETWORK_TRANSPORT = 'network.transport';
const NETWORK_TRANSPORT_VALUE_PIPE = "pipe";
const NETWORK_TRANSPORT_VALUE_QUIC = "quic";
const NETWORK_TRANSPORT_VALUE_TCP = "tcp";
const NETWORK_TRANSPORT_VALUE_UDP = "udp";
const NETWORK_TRANSPORT_VALUE_UNIX = "unix";
const ATTR_NETWORK_TYPE = 'network.type';
const NETWORK_TYPE_VALUE_IPV4 = "ipv4";
const NETWORK_TYPE_VALUE_IPV6 = "ipv6";
const ATTR_OTEL_SCOPE_NAME = 'otel.scope.name';
const ATTR_OTEL_SCOPE_VERSION = 'otel.scope.version';
const ATTR_OTEL_STATUS_CODE = 'otel.status_code';
const OTEL_STATUS_CODE_VALUE_ERROR = "ERROR";
const OTEL_STATUS_CODE_VALUE_OK = "OK";
const ATTR_OTEL_STATUS_DESCRIPTION = 'otel.status_description';
const ATTR_SERVER_ADDRESS = 'server.address';
const ATTR_SERVER_PORT = 'server.port';
const ATTR_SERVICE_NAME = 'service.name';
const ATTR_SERVICE_VERSION = 'service.version';
const ATTR_SIGNALR_CONNECTION_STATUS = 'signalr.connection.status';
const SIGNALR_CONNECTION_STATUS_VALUE_APP_SHUTDOWN = "app_shutdown";
const SIGNALR_CONNECTION_STATUS_VALUE_NORMAL_CLOSURE = "normal_closure";
const SIGNALR_CONNECTION_STATUS_VALUE_TIMEOUT = "timeout";
const ATTR_SIGNALR_TRANSPORT = 'signalr.transport';
const SIGNALR_TRANSPORT_VALUE_LONG_POLLING = "long_polling";
const SIGNALR_TRANSPORT_VALUE_SERVER_SENT_EVENTS = "server_sent_events";
const SIGNALR_TRANSPORT_VALUE_WEB_SOCKETS = "web_sockets";
const ATTR_TELEMETRY_SDK_LANGUAGE = 'telemetry.sdk.language';
const TELEMETRY_SDK_LANGUAGE_VALUE_CPP = "cpp";
const TELEMETRY_SDK_LANGUAGE_VALUE_DOTNET = "dotnet";
const TELEMETRY_SDK_LANGUAGE_VALUE_ERLANG = "erlang";
const TELEMETRY_SDK_LANGUAGE_VALUE_GO = "go";
const TELEMETRY_SDK_LANGUAGE_VALUE_JAVA = "java";
const TELEMETRY_SDK_LANGUAGE_VALUE_NODEJS = "nodejs";
const TELEMETRY_SDK_LANGUAGE_VALUE_PHP = "php";
const TELEMETRY_SDK_LANGUAGE_VALUE_PYTHON = "python";
const TELEMETRY_SDK_LANGUAGE_VALUE_RUBY = "ruby";
const TELEMETRY_SDK_LANGUAGE_VALUE_RUST = "rust";
const TELEMETRY_SDK_LANGUAGE_VALUE_SWIFT = "swift";
const TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS = "webjs";
const ATTR_TELEMETRY_SDK_NAME = 'telemetry.sdk.name';
const ATTR_TELEMETRY_SDK_VERSION = 'telemetry.sdk.version';
const ATTR_URL_FRAGMENT = 'url.fragment';
const ATTR_URL_FULL = 'url.full';
const ATTR_URL_PATH = 'url.path';
const ATTR_URL_QUERY = 'url.query';
const ATTR_URL_SCHEME = 'url.scheme';
const ATTR_USER_AGENT_ORIGINAL = 'user_agent.original';
;
function defaultServiceName() {
    return 'unknown_service';
}
;
const isPromiseLike = (val) => {
    return (val !== null &&
        typeof val === 'object' &&
        typeof val.then === 'function');
};
function identity(_) {
    return _;
}
;





class ResourceImpl {
    _rawAttributes;
    _asyncAttributesPending = false;
    _memoizedAttributes;
    static FromAttributeList(attributes) {
        const res = new ResourceImpl({});
        res._rawAttributes = attributes;
        res._asyncAttributesPending =
            attributes.filter(([_, val]) => isPromiseLike(val)).length > 0;
        return res;
    }
    constructor(
    resource) {
        const attributes = resource.attributes ?? {};
        this._rawAttributes = Object.entries(attributes).map(([k, v]) => {
            if (isPromiseLike(v)) {
                this._asyncAttributesPending = true;
            }
            return [k, v];
        });
    }
    get asyncAttributesPending() {
        return this._asyncAttributesPending;
    }
    async waitForAsyncAttributes() {
        if (!this.asyncAttributesPending) {
            return;
        }
        for (let i = 0; i < this._rawAttributes.length; i++) {
            const [k, v] = this._rawAttributes[i];
            try {
                this._rawAttributes[i] = [k, isPromiseLike(v) ? await v : v];
            }
            catch (err) {
                diag.debug("a resource's async attributes promise rejected: %s", err);
                this._rawAttributes[i] = [k, undefined];
            }
        }
        this._asyncAttributesPending = false;
    }
    get attributes() {
        if (this.asyncAttributesPending) {
            diag.error('Accessing resource attributes before async attributes settled');
        }
        if (this._memoizedAttributes) {
            return this._memoizedAttributes;
        }
        const attrs = {};
        for (const [k, v] of this._rawAttributes) {
            if (isPromiseLike(v)) {
                diag.debug(`Unsettled resource attribute ${k} skipped`);
                continue;
            }
            if (v != null) {
                attrs[k] ??= v;
            }
        }
        if (!this._asyncAttributesPending) {
            this._memoizedAttributes = attrs;
        }
        return attrs;
    }
    getRawAttributes() {
        return this._rawAttributes;
    }
    merge(resource) {
        if (resource == null)
            return this;
        return ResourceImpl.FromAttributeList([
            ...resource.getRawAttributes(),
            ...this.getRawAttributes(),
        ]);
    }
}
function resourceFromAttributes(attributes) {
    return ResourceImpl.FromAttributeList(Object.entries(attributes));
}
function resourceFromDetectedResource(detectedResource) {
    return new ResourceImpl(detectedResource);
}
function emptyResource() {
    return resourceFromAttributes({});
}
function defaultResource() {
    return resourceFromAttributes({
        [ATTR_SERVICE_NAME]: defaultServiceName(),
        [ATTR_TELEMETRY_SDK_LANGUAGE]: SDK_INFO[ATTR_TELEMETRY_SDK_LANGUAGE],
        [ATTR_TELEMETRY_SDK_NAME]: SDK_INFO[ATTR_TELEMETRY_SDK_NAME],
        [ATTR_TELEMETRY_SDK_VERSION]: SDK_INFO[ATTR_TELEMETRY_SDK_VERSION],
    });
}
;
function createContextKey(description) {
    return Symbol.for(description);
}
var BaseContext =  (function () {
    function BaseContext(parentContext) {
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function (key) { return self._currentContext.get(key); };
        self.setValue = function (key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function (key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}());
var ROOT_CONTEXT = new BaseContext();
;
var NoopContextManager_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var NoopContextManager_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var NoopContextManager =  (function () {
    function NoopContextManager() {
    }
    NoopContextManager.prototype.active = function () {
        return ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function (_context, fn, thisArg) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        return fn.call.apply(fn, NoopContextManager_spreadArray([thisArg], NoopContextManager_read(args), false));
    };
    NoopContextManager.prototype.bind = function (_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function () {
        return this;
    };
    NoopContextManager.prototype.disable = function () {
        return this;
    };
    return NoopContextManager;
}());

;
var context_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var context_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};



var context_API_NAME = 'context';
var NOOP_CONTEXT_MANAGER = new NoopContextManager();
var ContextAPI =  (function () {
    function ContextAPI() {
    }
    ContextAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new ContextAPI();
        }
        return this._instance;
    };
    ContextAPI.prototype.setGlobalContextManager = function (contextManager) {
        return registerGlobal(context_API_NAME, contextManager, DiagAPI.instance());
    };
    ContextAPI.prototype.active = function () {
        return this._getContextManager().active();
    };
    ContextAPI.prototype.with = function (context, fn, thisArg) {
        var _a;
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        return (_a = this._getContextManager()).with.apply(_a, context_spreadArray([context, fn, thisArg], context_read(args), false));
    };
    ContextAPI.prototype.bind = function (context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function () {
        return getGlobal(context_API_NAME) || NOOP_CONTEXT_MANAGER;
    };
    ContextAPI.prototype.disable = function () {
        this._getContextManager().disable();
        unregisterGlobal(context_API_NAME, DiagAPI.instance());
    };
    return ContextAPI;
}());

;

var context_api_context = ContextAPI.getInstance();
;
var TraceFlags;
(function (TraceFlags) {
    TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags || (TraceFlags = {}));
;

var INVALID_SPANID = '0000000000000000';
var INVALID_TRACEID = '00000000000000000000000000000000';
var INVALID_SPAN_CONTEXT = {
    traceId: INVALID_TRACEID,
    spanId: INVALID_SPANID,
    traceFlags: TraceFlags.NONE,
};
;

var NonRecordingSpan =  (function () {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) { _spanContext = INVALID_SPAN_CONTEXT; }
        this._spanContext = _spanContext;
    }
    NonRecordingSpan.prototype.spanContext = function () {
        return this._spanContext;
    };
    NonRecordingSpan.prototype.setAttribute = function (_key, _value) {
        return this;
    };
    NonRecordingSpan.prototype.setAttributes = function (_attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addEvent = function (_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function (_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function (_links) {
        return this;
    };
    NonRecordingSpan.prototype.setStatus = function (_status) {
        return this;
    };
    NonRecordingSpan.prototype.updateName = function (_name) {
        return this;
    };
    NonRecordingSpan.prototype.end = function (_endTime) { };
    NonRecordingSpan.prototype.isRecording = function () {
        return false;
    };
    NonRecordingSpan.prototype.recordException = function (_exception, _time) { };
    return NonRecordingSpan;
}());

;



var SPAN_KEY = createContextKey('OpenTelemetry Context Key SPAN');
function getSpan(context) {
    return context.getValue(SPAN_KEY) || undefined;
}
function getActiveSpan() {
    return getSpan(ContextAPI.getInstance().active());
}
function setSpan(context, span) {
    return context.setValue(SPAN_KEY, span);
}
function deleteSpan(context) {
    return context.deleteValue(SPAN_KEY);
}
function setSpanContext(context, spanContext) {
    return setSpan(context, new NonRecordingSpan(spanContext));
}
function getSpanContext(context) {
    var _a;
    return (_a = getSpan(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}
;


var VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function isValidTraceId(traceId) {
    return VALID_TRACEID_REGEX.test(traceId) && traceId !== INVALID_TRACEID;
}
function isValidSpanId(spanId) {
    return VALID_SPANID_REGEX.test(spanId) && spanId !== INVALID_SPANID;
}
function isSpanContextValid(spanContext) {
    return (isValidTraceId(spanContext.traceId) && isValidSpanId(spanContext.spanId));
}
function wrapSpanContext(spanContext) {
    return new NonRecordingSpan(spanContext);
}
;




var contextApi = ContextAPI.getInstance();
var NoopTracer =  (function () {
    function NoopTracer() {
    }
    NoopTracer.prototype.startSpan = function (name, options, context) {
        if (context === void 0) { context = contextApi.active(); }
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) {
            return new NonRecordingSpan();
        }
        var parentFromContext = context && getSpanContext(context);
        if (isSpanContext(parentFromContext) &&
            isSpanContextValid(parentFromContext)) {
            return new NonRecordingSpan(parentFromContext);
        }
        else {
            return new NonRecordingSpan();
        }
    };
    NoopTracer.prototype.startActiveSpan = function (name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) {
            return;
        }
        else if (arguments.length === 2) {
            fn = arg2;
        }
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        }
        else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = setSpan(parentContext, span);
        return contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}());

function isSpanContext(spanContext) {
    return (typeof spanContext === 'object' &&
        typeof spanContext['spanId'] === 'string' &&
        typeof spanContext['traceId'] === 'string' &&
        typeof spanContext['traceFlags'] === 'number');
}
;

var NOOP_TRACER = new NoopTracer();
var ProxyTracer =  (function () {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function (name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function (_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    ProxyTracer.prototype._getTracer = function () {
        if (this._delegate) {
            return this._delegate;
        }
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) {
            return NOOP_TRACER;
        }
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}());

;

var NoopTracerProvider =  (function () {
    function NoopTracerProvider() {
    }
    NoopTracerProvider.prototype.getTracer = function (_name, _version, _options) {
        return new NoopTracer();
    };
    return NoopTracerProvider;
}());

;


var NOOP_TRACER_PROVIDER = new NoopTracerProvider();
var ProxyTracerProvider =  (function () {
    function ProxyTracerProvider() {
    }
    ProxyTracerProvider.prototype.getTracer = function (name, version, options) {
        var _a;
        return ((_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new ProxyTracer(this, name, version, options));
    };
    ProxyTracerProvider.prototype.getDelegate = function () {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER;
    };
    ProxyTracerProvider.prototype.setDelegate = function (delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function (name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}());

;





var trace_API_NAME = 'trace';
var TraceAPI =  (function () {
    function TraceAPI() {
        this._proxyTracerProvider = new ProxyTracerProvider();
        this.wrapSpanContext = wrapSpanContext;
        this.isSpanContextValid = isSpanContextValid;
        this.deleteSpan = deleteSpan;
        this.getSpan = getSpan;
        this.getActiveSpan = getActiveSpan;
        this.getSpanContext = getSpanContext;
        this.setSpan = setSpan;
        this.setSpanContext = setSpanContext;
    }
    TraceAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new TraceAPI();
        }
        return this._instance;
    };
    TraceAPI.prototype.setGlobalTracerProvider = function (provider) {
        var success = registerGlobal(trace_API_NAME, this._proxyTracerProvider, DiagAPI.instance());
        if (success) {
            this._proxyTracerProvider.setDelegate(provider);
        }
        return success;
    };
    TraceAPI.prototype.getTracerProvider = function () {
        return getGlobal(trace_API_NAME) || this._proxyTracerProvider;
    };
    TraceAPI.prototype.getTracer = function (name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    TraceAPI.prototype.disable = function () {
        unregisterGlobal(trace_API_NAME, DiagAPI.instance());
        this._proxyTracerProvider = new ProxyTracerProvider();
    };
    return TraceAPI;
}());

;

var trace = TraceAPI.getInstance();
;
var SpanKind;
(function (SpanKind) {
    SpanKind[SpanKind["INTERNAL"] = 0] = "INTERNAL";
    SpanKind[SpanKind["SERVER"] = 1] = "SERVER";
    SpanKind[SpanKind["CLIENT"] = 2] = "CLIENT";
    SpanKind[SpanKind["PRODUCER"] = 3] = "PRODUCER";
    SpanKind[SpanKind["CONSUMER"] = 4] = "CONSUMER";
})(SpanKind || (SpanKind = {}));
;
var SamplingDecision;
(function (SamplingDecision) {
    SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})(SamplingDecision || (SamplingDecision = {}));
;

const SUPPRESS_TRACING_KEY = createContextKey('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function suppressTracing(context) {
    return context.setValue(SUPPRESS_TRACING_KEY, true);
}
function unsuppressTracing(context) {
    return context.deleteValue(SUPPRESS_TRACING_KEY);
}
function isTracingSuppressed(context) {
    return context.getValue(SUPPRESS_TRACING_KEY) === true;
}
;

function sanitizeAttributes(attributes) {
    const out = {};
    if (typeof attributes !== 'object' || attributes == null) {
        return out;
    }
    for (const [key, val] of Object.entries(attributes)) {
        if (!isAttributeKey(key)) {
            diag.warn(`Invalid attribute key: ${key}`);
            continue;
        }
        if (!isAttributeValue(val)) {
            diag.warn(`Invalid attribute value set for key: ${key}`);
            continue;
        }
        if (Array.isArray(val)) {
            out[key] = val.slice();
        }
        else {
            out[key] = val;
        }
    }
    return out;
}
function isAttributeKey(key) {
    return typeof key === 'string' && key.length > 0;
}
function isAttributeValue(val) {
    if (val == null) {
        return true;
    }
    if (Array.isArray(val)) {
        return isHomogeneousAttributeValueArray(val);
    }
    return isValidPrimitiveAttributeValue(val);
}
function isHomogeneousAttributeValueArray(arr) {
    let type;
    for (const element of arr) {
        if (element == null)
            continue;
        if (!type) {
            if (isValidPrimitiveAttributeValue(element)) {
                type = typeof element;
                continue;
            }
            return false;
        }
        if (typeof element === type) {
            continue;
        }
        return false;
    }
    return true;
}
function isValidPrimitiveAttributeValue(val) {
    switch (typeof val) {
        case 'number':
        case 'boolean':
        case 'string':
            return true;
    }
    return false;
}
;
var SpanStatusCode;
(function (SpanStatusCode) {
    SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})(SpanStatusCode || (SpanStatusCode = {}));
;
const otperformance = performance;
;

const NANOSECOND_DIGITS = 9;
const NANOSECOND_DIGITS_IN_MILLIS = 6;
const MILLISECONDS_TO_NANOSECONDS = Math.pow(10, NANOSECOND_DIGITS_IN_MILLIS);
const SECOND_TO_NANOSECONDS = Math.pow(10, NANOSECOND_DIGITS);
function millisToHrTime(epochMillis) {
    const epochSeconds = epochMillis / 1000;
    const seconds = Math.trunc(epochSeconds);
    const nanos = Math.round((epochMillis % 1000) * MILLISECONDS_TO_NANOSECONDS);
    return [seconds, nanos];
}
function getTimeOrigin() {
    let timeOrigin = otperformance.timeOrigin;
    if (typeof timeOrigin !== 'number') {
        const perf = otperformance;
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function hrTime(performanceNow) {
    const timeOrigin = millisToHrTime(getTimeOrigin());
    const now = millisToHrTime(typeof performanceNow === 'number' ? performanceNow : otperformance.now());
    return addHrTimes(timeOrigin, now);
}
function timeInputToHrTime(time) {
    if (isTimeInputHrTime(time)) {
        return time;
    }
    else if (typeof time === 'number') {
        if (time < getTimeOrigin()) {
            return hrTime(time);
        }
        else {
            return millisToHrTime(time);
        }
    }
    else if (time instanceof Date) {
        return millisToHrTime(time.getTime());
    }
    else {
        throw TypeError('Invalid input type');
    }
}
function hrTimeDuration(startTime, endTime) {
    let seconds = endTime[0] - startTime[0];
    let nanos = endTime[1] - startTime[1];
    if (nanos < 0) {
        seconds -= 1;
        nanos += SECOND_TO_NANOSECONDS;
    }
    return [seconds, nanos];
}
function hrTimeToTimeStamp(time) {
    const precision = NANOSECOND_DIGITS;
    const tmp = `${'0'.repeat(precision)}${time[1]}Z`;
    const nanoString = tmp.substring(tmp.length - precision - 1);
    const date = new Date(time[0] * 1000).toISOString();
    return date.replace('000Z', nanoString);
}
function hrTimeToNanoseconds(time) {
    return time[0] * SECOND_TO_NANOSECONDS + time[1];
}
function hrTimeToMilliseconds(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function hrTimeToMicroseconds(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function isTimeInputHrTime(value) {
    return (Array.isArray(value) &&
        value.length === 2 &&
        typeof value[0] === 'number' &&
        typeof value[1] === 'number');
}
function isTimeInput(value) {
    return (isTimeInputHrTime(value) ||
        typeof value === 'number' ||
        value instanceof Date);
}
function addHrTimes(time1, time2) {
    const out = [time1[0] + time2[0], time1[1] + time2[1]];
    if (out[1] >= SECOND_TO_NANOSECONDS) {
        out[1] -= SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}
;
function utils_createConstMap(values) {
    let res = {};
    const len = values.length;
    for (let lp = 0; lp < len; lp++) {
        const val = values[lp];
        if (val) {
            res[String(val).toUpperCase().replace(/[-.]/g, '_')] = val;
        }
    }
    return res;
}
;

const TMP_AWS_LAMBDA_INVOKED_ARN = 'aws.lambda.invoked_arn';
const TMP_DB_SYSTEM = 'db.system';
const TMP_DB_CONNECTION_STRING = 'db.connection_string';
const TMP_DB_USER = 'db.user';
const TMP_DB_JDBC_DRIVER_CLASSNAME = 'db.jdbc.driver_classname';
const TMP_DB_NAME = 'db.name';
const TMP_DB_STATEMENT = 'db.statement';
const TMP_DB_OPERATION = 'db.operation';
const TMP_DB_MSSQL_INSTANCE_NAME = 'db.mssql.instance_name';
const TMP_DB_CASSANDRA_KEYSPACE = 'db.cassandra.keyspace';
const TMP_DB_CASSANDRA_PAGE_SIZE = 'db.cassandra.page_size';
const TMP_DB_CASSANDRA_CONSISTENCY_LEVEL = 'db.cassandra.consistency_level';
const TMP_DB_CASSANDRA_TABLE = 'db.cassandra.table';
const TMP_DB_CASSANDRA_IDEMPOTENCE = 'db.cassandra.idempotence';
const TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = 'db.cassandra.speculative_execution_count';
const TMP_DB_CASSANDRA_COORDINATOR_ID = 'db.cassandra.coordinator.id';
const TMP_DB_CASSANDRA_COORDINATOR_DC = 'db.cassandra.coordinator.dc';
const TMP_DB_HBASE_NAMESPACE = 'db.hbase.namespace';
const TMP_DB_REDIS_DATABASE_INDEX = 'db.redis.database_index';
const TMP_DB_MONGODB_COLLECTION = 'db.mongodb.collection';
const TMP_DB_SQL_TABLE = 'db.sql.table';
const TMP_EXCEPTION_TYPE = 'exception.type';
const TMP_EXCEPTION_MESSAGE = 'exception.message';
const TMP_EXCEPTION_STACKTRACE = 'exception.stacktrace';
const TMP_EXCEPTION_ESCAPED = 'exception.escaped';
const TMP_FAAS_TRIGGER = 'faas.trigger';
const TMP_FAAS_EXECUTION = 'faas.execution';
const TMP_FAAS_DOCUMENT_COLLECTION = 'faas.document.collection';
const TMP_FAAS_DOCUMENT_OPERATION = 'faas.document.operation';
const TMP_FAAS_DOCUMENT_TIME = 'faas.document.time';
const TMP_FAAS_DOCUMENT_NAME = 'faas.document.name';
const TMP_FAAS_TIME = 'faas.time';
const TMP_FAAS_CRON = 'faas.cron';
const TMP_FAAS_COLDSTART = 'faas.coldstart';
const TMP_FAAS_INVOKED_NAME = 'faas.invoked_name';
const TMP_FAAS_INVOKED_PROVIDER = 'faas.invoked_provider';
const TMP_FAAS_INVOKED_REGION = 'faas.invoked_region';
const TMP_NET_TRANSPORT = 'net.transport';
const TMP_NET_PEER_IP = 'net.peer.ip';
const TMP_NET_PEER_PORT = 'net.peer.port';
const TMP_NET_PEER_NAME = 'net.peer.name';
const TMP_NET_HOST_IP = 'net.host.ip';
const TMP_NET_HOST_PORT = 'net.host.port';
const TMP_NET_HOST_NAME = 'net.host.name';
const TMP_NET_HOST_CONNECTION_TYPE = 'net.host.connection.type';
const TMP_NET_HOST_CONNECTION_SUBTYPE = 'net.host.connection.subtype';
const TMP_NET_HOST_CARRIER_NAME = 'net.host.carrier.name';
const TMP_NET_HOST_CARRIER_MCC = 'net.host.carrier.mcc';
const TMP_NET_HOST_CARRIER_MNC = 'net.host.carrier.mnc';
const TMP_NET_HOST_CARRIER_ICC = 'net.host.carrier.icc';
const TMP_PEER_SERVICE = 'peer.service';
const TMP_ENDUSER_ID = 'enduser.id';
const TMP_ENDUSER_ROLE = 'enduser.role';
const TMP_ENDUSER_SCOPE = 'enduser.scope';
const TMP_THREAD_ID = 'thread.id';
const TMP_THREAD_NAME = 'thread.name';
const TMP_CODE_FUNCTION = 'code.function';
const TMP_CODE_NAMESPACE = 'code.namespace';
const TMP_CODE_FILEPATH = 'code.filepath';
const TMP_CODE_LINENO = 'code.lineno';
const TMP_HTTP_METHOD = 'http.method';
const TMP_HTTP_URL = 'http.url';
const TMP_HTTP_TARGET = 'http.target';
const TMP_HTTP_HOST = 'http.host';
const TMP_HTTP_SCHEME = 'http.scheme';
const TMP_HTTP_STATUS_CODE = 'http.status_code';
const TMP_HTTP_FLAVOR = 'http.flavor';
const TMP_HTTP_USER_AGENT = 'http.user_agent';
const TMP_HTTP_REQUEST_CONTENT_LENGTH = 'http.request_content_length';
const TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = 'http.request_content_length_uncompressed';
const TMP_HTTP_RESPONSE_CONTENT_LENGTH = 'http.response_content_length';
const TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = 'http.response_content_length_uncompressed';
const TMP_HTTP_SERVER_NAME = 'http.server_name';
const TMP_HTTP_ROUTE = 'http.route';
const TMP_HTTP_CLIENT_IP = 'http.client_ip';
const TMP_AWS_DYNAMODB_TABLE_NAMES = 'aws.dynamodb.table_names';
const TMP_AWS_DYNAMODB_CONSUMED_CAPACITY = 'aws.dynamodb.consumed_capacity';
const TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = 'aws.dynamodb.item_collection_metrics';
const TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = 'aws.dynamodb.provisioned_read_capacity';
const TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = 'aws.dynamodb.provisioned_write_capacity';
const TMP_AWS_DYNAMODB_CONSISTENT_READ = 'aws.dynamodb.consistent_read';
const TMP_AWS_DYNAMODB_PROJECTION = 'aws.dynamodb.projection';
const TMP_AWS_DYNAMODB_LIMIT = 'aws.dynamodb.limit';
const TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET = 'aws.dynamodb.attributes_to_get';
const TMP_AWS_DYNAMODB_INDEX_NAME = 'aws.dynamodb.index_name';
const TMP_AWS_DYNAMODB_SELECT = 'aws.dynamodb.select';
const TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = 'aws.dynamodb.global_secondary_indexes';
const TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = 'aws.dynamodb.local_secondary_indexes';
const TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = 'aws.dynamodb.exclusive_start_table';
const TMP_AWS_DYNAMODB_TABLE_COUNT = 'aws.dynamodb.table_count';
const TMP_AWS_DYNAMODB_SCAN_FORWARD = 'aws.dynamodb.scan_forward';
const TMP_AWS_DYNAMODB_SEGMENT = 'aws.dynamodb.segment';
const TMP_AWS_DYNAMODB_TOTAL_SEGMENTS = 'aws.dynamodb.total_segments';
const TMP_AWS_DYNAMODB_COUNT = 'aws.dynamodb.count';
const TMP_AWS_DYNAMODB_SCANNED_COUNT = 'aws.dynamodb.scanned_count';
const TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = 'aws.dynamodb.attribute_definitions';
const TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = 'aws.dynamodb.global_secondary_index_updates';
const TMP_MESSAGING_SYSTEM = 'messaging.system';
const TMP_MESSAGING_DESTINATION = 'messaging.destination';
const TMP_MESSAGING_DESTINATION_KIND = 'messaging.destination_kind';
const TMP_MESSAGING_TEMP_DESTINATION = 'messaging.temp_destination';
const TMP_MESSAGING_PROTOCOL = 'messaging.protocol';
const TMP_MESSAGING_PROTOCOL_VERSION = 'messaging.protocol_version';
const TMP_MESSAGING_URL = 'messaging.url';
const TMP_MESSAGING_MESSAGE_ID = 'messaging.message_id';
const TMP_MESSAGING_CONVERSATION_ID = 'messaging.conversation_id';
const TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = 'messaging.message_payload_size_bytes';
const TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = 'messaging.message_payload_compressed_size_bytes';
const TMP_MESSAGING_OPERATION = 'messaging.operation';
const TMP_MESSAGING_CONSUMER_ID = 'messaging.consumer_id';
const TMP_MESSAGING_RABBITMQ_ROUTING_KEY = 'messaging.rabbitmq.routing_key';
const TMP_MESSAGING_KAFKA_MESSAGE_KEY = 'messaging.kafka.message_key';
const TMP_MESSAGING_KAFKA_CONSUMER_GROUP = 'messaging.kafka.consumer_group';
const TMP_MESSAGING_KAFKA_CLIENT_ID = 'messaging.kafka.client_id';
const TMP_MESSAGING_KAFKA_PARTITION = 'messaging.kafka.partition';
const TMP_MESSAGING_KAFKA_TOMBSTONE = 'messaging.kafka.tombstone';
const TMP_RPC_SYSTEM = 'rpc.system';
const TMP_RPC_SERVICE = 'rpc.service';
const TMP_RPC_METHOD = 'rpc.method';
const TMP_RPC_GRPC_STATUS_CODE = 'rpc.grpc.status_code';
const TMP_RPC_JSONRPC_VERSION = 'rpc.jsonrpc.version';
const TMP_RPC_JSONRPC_REQUEST_ID = 'rpc.jsonrpc.request_id';
const TMP_RPC_JSONRPC_ERROR_CODE = 'rpc.jsonrpc.error_code';
const TMP_RPC_JSONRPC_ERROR_MESSAGE = 'rpc.jsonrpc.error_message';
const TMP_MESSAGE_TYPE = 'message.type';
const TMP_MESSAGE_ID = 'message.id';
const TMP_MESSAGE_COMPRESSED_SIZE = 'message.compressed_size';
const TMP_MESSAGE_UNCOMPRESSED_SIZE = 'message.uncompressed_size';
const SEMATTRS_AWS_LAMBDA_INVOKED_ARN = ( null && (TMP_AWS_LAMBDA_INVOKED_ARN));
const SEMATTRS_DB_SYSTEM = ( null && (TMP_DB_SYSTEM));
const SEMATTRS_DB_CONNECTION_STRING = ( null && (TMP_DB_CONNECTION_STRING));
const SEMATTRS_DB_USER = ( null && (TMP_DB_USER));
const SEMATTRS_DB_JDBC_DRIVER_CLASSNAME = ( null && (TMP_DB_JDBC_DRIVER_CLASSNAME));
const SEMATTRS_DB_NAME = ( null && (TMP_DB_NAME));
const SEMATTRS_DB_STATEMENT = ( null && (TMP_DB_STATEMENT));
const SEMATTRS_DB_OPERATION = ( null && (TMP_DB_OPERATION));
const SEMATTRS_DB_MSSQL_INSTANCE_NAME = ( null && (TMP_DB_MSSQL_INSTANCE_NAME));
const SEMATTRS_DB_CASSANDRA_KEYSPACE = ( null && (TMP_DB_CASSANDRA_KEYSPACE));
const SEMATTRS_DB_CASSANDRA_PAGE_SIZE = ( null && (TMP_DB_CASSANDRA_PAGE_SIZE));
const SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL = ( null && (TMP_DB_CASSANDRA_CONSISTENCY_LEVEL));
const SEMATTRS_DB_CASSANDRA_TABLE = ( null && (TMP_DB_CASSANDRA_TABLE));
const SEMATTRS_DB_CASSANDRA_IDEMPOTENCE = ( null && (TMP_DB_CASSANDRA_IDEMPOTENCE));
const SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = ( null && (TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT));
const SEMATTRS_DB_CASSANDRA_COORDINATOR_ID = ( null && (TMP_DB_CASSANDRA_COORDINATOR_ID));
const SEMATTRS_DB_CASSANDRA_COORDINATOR_DC = ( null && (TMP_DB_CASSANDRA_COORDINATOR_DC));
const SEMATTRS_DB_HBASE_NAMESPACE = ( null && (TMP_DB_HBASE_NAMESPACE));
const SEMATTRS_DB_REDIS_DATABASE_INDEX = ( null && (TMP_DB_REDIS_DATABASE_INDEX));
const SEMATTRS_DB_MONGODB_COLLECTION = ( null && (TMP_DB_MONGODB_COLLECTION));
const SEMATTRS_DB_SQL_TABLE = ( null && (TMP_DB_SQL_TABLE));
const SEMATTRS_EXCEPTION_TYPE = TMP_EXCEPTION_TYPE;
const SEMATTRS_EXCEPTION_MESSAGE = TMP_EXCEPTION_MESSAGE;
const SEMATTRS_EXCEPTION_STACKTRACE = TMP_EXCEPTION_STACKTRACE;
const SEMATTRS_EXCEPTION_ESCAPED = ( null && (TMP_EXCEPTION_ESCAPED));
const SEMATTRS_FAAS_TRIGGER = ( null && (TMP_FAAS_TRIGGER));
const SEMATTRS_FAAS_EXECUTION = ( null && (TMP_FAAS_EXECUTION));
const SEMATTRS_FAAS_DOCUMENT_COLLECTION = ( null && (TMP_FAAS_DOCUMENT_COLLECTION));
const SEMATTRS_FAAS_DOCUMENT_OPERATION = ( null && (TMP_FAAS_DOCUMENT_OPERATION));
const SEMATTRS_FAAS_DOCUMENT_TIME = ( null && (TMP_FAAS_DOCUMENT_TIME));
const SEMATTRS_FAAS_DOCUMENT_NAME = ( null && (TMP_FAAS_DOCUMENT_NAME));
const SEMATTRS_FAAS_TIME = ( null && (TMP_FAAS_TIME));
const SEMATTRS_FAAS_CRON = ( null && (TMP_FAAS_CRON));
const SEMATTRS_FAAS_COLDSTART = ( null && (TMP_FAAS_COLDSTART));
const SEMATTRS_FAAS_INVOKED_NAME = ( null && (TMP_FAAS_INVOKED_NAME));
const SEMATTRS_FAAS_INVOKED_PROVIDER = ( null && (TMP_FAAS_INVOKED_PROVIDER));
const SEMATTRS_FAAS_INVOKED_REGION = ( null && (TMP_FAAS_INVOKED_REGION));
const SEMATTRS_NET_TRANSPORT = ( null && (TMP_NET_TRANSPORT));
const SEMATTRS_NET_PEER_IP = ( null && (TMP_NET_PEER_IP));
const SEMATTRS_NET_PEER_PORT = ( null && (TMP_NET_PEER_PORT));
const SEMATTRS_NET_PEER_NAME = ( null && (TMP_NET_PEER_NAME));
const SEMATTRS_NET_HOST_IP = ( null && (TMP_NET_HOST_IP));
const SEMATTRS_NET_HOST_PORT = ( null && (TMP_NET_HOST_PORT));
const SEMATTRS_NET_HOST_NAME = ( null && (TMP_NET_HOST_NAME));
const SEMATTRS_NET_HOST_CONNECTION_TYPE = ( null && (TMP_NET_HOST_CONNECTION_TYPE));
const SEMATTRS_NET_HOST_CONNECTION_SUBTYPE = ( null && (TMP_NET_HOST_CONNECTION_SUBTYPE));
const SEMATTRS_NET_HOST_CARRIER_NAME = ( null && (TMP_NET_HOST_CARRIER_NAME));
const SEMATTRS_NET_HOST_CARRIER_MCC = ( null && (TMP_NET_HOST_CARRIER_MCC));
const SEMATTRS_NET_HOST_CARRIER_MNC = ( null && (TMP_NET_HOST_CARRIER_MNC));
const SEMATTRS_NET_HOST_CARRIER_ICC = ( null && (TMP_NET_HOST_CARRIER_ICC));
const SEMATTRS_PEER_SERVICE = ( null && (TMP_PEER_SERVICE));
const SEMATTRS_ENDUSER_ID = ( null && (TMP_ENDUSER_ID));
const SEMATTRS_ENDUSER_ROLE = ( null && (TMP_ENDUSER_ROLE));
const SEMATTRS_ENDUSER_SCOPE = ( null && (TMP_ENDUSER_SCOPE));
const SEMATTRS_THREAD_ID = ( null && (TMP_THREAD_ID));
const SEMATTRS_THREAD_NAME = ( null && (TMP_THREAD_NAME));
const SEMATTRS_CODE_FUNCTION = ( null && (TMP_CODE_FUNCTION));
const SEMATTRS_CODE_NAMESPACE = ( null && (TMP_CODE_NAMESPACE));
const SEMATTRS_CODE_FILEPATH = ( null && (TMP_CODE_FILEPATH));
const SEMATTRS_CODE_LINENO = ( null && (TMP_CODE_LINENO));
const SEMATTRS_HTTP_METHOD = ( null && (TMP_HTTP_METHOD));
const SEMATTRS_HTTP_URL = ( null && (TMP_HTTP_URL));
const SEMATTRS_HTTP_TARGET = ( null && (TMP_HTTP_TARGET));
const SEMATTRS_HTTP_HOST = ( null && (TMP_HTTP_HOST));
const SEMATTRS_HTTP_SCHEME = ( null && (TMP_HTTP_SCHEME));
const SEMATTRS_HTTP_STATUS_CODE = ( null && (TMP_HTTP_STATUS_CODE));
const SEMATTRS_HTTP_FLAVOR = ( null && (TMP_HTTP_FLAVOR));
const SEMATTRS_HTTP_USER_AGENT = ( null && (TMP_HTTP_USER_AGENT));
const SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH = ( null && (TMP_HTTP_REQUEST_CONTENT_LENGTH));
const SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = ( null && (TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED));
const SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH = ( null && (TMP_HTTP_RESPONSE_CONTENT_LENGTH));
const SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = ( null && (TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED));
const SEMATTRS_HTTP_SERVER_NAME = ( null && (TMP_HTTP_SERVER_NAME));
const SEMATTRS_HTTP_ROUTE = ( null && (TMP_HTTP_ROUTE));
const SEMATTRS_HTTP_CLIENT_IP = ( null && (TMP_HTTP_CLIENT_IP));
const SEMATTRS_AWS_DYNAMODB_TABLE_NAMES = ( null && (TMP_AWS_DYNAMODB_TABLE_NAMES));
const SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY = ( null && (TMP_AWS_DYNAMODB_CONSUMED_CAPACITY));
const SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = ( null && (TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS));
const SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = ( null && (TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY));
const SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = ( null && (TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY));
const SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ = ( null && (TMP_AWS_DYNAMODB_CONSISTENT_READ));
const SEMATTRS_AWS_DYNAMODB_PROJECTION = ( null && (TMP_AWS_DYNAMODB_PROJECTION));
const SEMATTRS_AWS_DYNAMODB_LIMIT = ( null && (TMP_AWS_DYNAMODB_LIMIT));
const SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET = ( null && (TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET));
const SEMATTRS_AWS_DYNAMODB_INDEX_NAME = ( null && (TMP_AWS_DYNAMODB_INDEX_NAME));
const SEMATTRS_AWS_DYNAMODB_SELECT = ( null && (TMP_AWS_DYNAMODB_SELECT));
const SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = ( null && (TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES));
const SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = ( null && (TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES));
const SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = ( null && (TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE));
const SEMATTRS_AWS_DYNAMODB_TABLE_COUNT = ( null && (TMP_AWS_DYNAMODB_TABLE_COUNT));
const SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD = ( null && (TMP_AWS_DYNAMODB_SCAN_FORWARD));
const SEMATTRS_AWS_DYNAMODB_SEGMENT = ( null && (TMP_AWS_DYNAMODB_SEGMENT));
const SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS = ( null && (TMP_AWS_DYNAMODB_TOTAL_SEGMENTS));
const SEMATTRS_AWS_DYNAMODB_COUNT = ( null && (TMP_AWS_DYNAMODB_COUNT));
const SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT = ( null && (TMP_AWS_DYNAMODB_SCANNED_COUNT));
const SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = ( null && (TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS));
const SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = ( null && (TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES));
const SEMATTRS_MESSAGING_SYSTEM = ( null && (TMP_MESSAGING_SYSTEM));
const SEMATTRS_MESSAGING_DESTINATION = ( null && (TMP_MESSAGING_DESTINATION));
const SEMATTRS_MESSAGING_DESTINATION_KIND = ( null && (TMP_MESSAGING_DESTINATION_KIND));
const SEMATTRS_MESSAGING_TEMP_DESTINATION = ( null && (TMP_MESSAGING_TEMP_DESTINATION));
const SEMATTRS_MESSAGING_PROTOCOL = ( null && (TMP_MESSAGING_PROTOCOL));
const SEMATTRS_MESSAGING_PROTOCOL_VERSION = ( null && (TMP_MESSAGING_PROTOCOL_VERSION));
const SEMATTRS_MESSAGING_URL = ( null && (TMP_MESSAGING_URL));
const SEMATTRS_MESSAGING_MESSAGE_ID = ( null && (TMP_MESSAGING_MESSAGE_ID));
const SEMATTRS_MESSAGING_CONVERSATION_ID = ( null && (TMP_MESSAGING_CONVERSATION_ID));
const SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = ( null && (TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES));
const SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = ( null && (TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES));
const SEMATTRS_MESSAGING_OPERATION = ( null && (TMP_MESSAGING_OPERATION));
const SEMATTRS_MESSAGING_CONSUMER_ID = ( null && (TMP_MESSAGING_CONSUMER_ID));
const SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY = ( null && (TMP_MESSAGING_RABBITMQ_ROUTING_KEY));
const SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY = ( null && (TMP_MESSAGING_KAFKA_MESSAGE_KEY));
const SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP = ( null && (TMP_MESSAGING_KAFKA_CONSUMER_GROUP));
const SEMATTRS_MESSAGING_KAFKA_CLIENT_ID = ( null && (TMP_MESSAGING_KAFKA_CLIENT_ID));
const SEMATTRS_MESSAGING_KAFKA_PARTITION = ( null && (TMP_MESSAGING_KAFKA_PARTITION));
const SEMATTRS_MESSAGING_KAFKA_TOMBSTONE = ( null && (TMP_MESSAGING_KAFKA_TOMBSTONE));
const SEMATTRS_RPC_SYSTEM = ( null && (TMP_RPC_SYSTEM));
const SEMATTRS_RPC_SERVICE = ( null && (TMP_RPC_SERVICE));
const SEMATTRS_RPC_METHOD = ( null && (TMP_RPC_METHOD));
const SEMATTRS_RPC_GRPC_STATUS_CODE = ( null && (TMP_RPC_GRPC_STATUS_CODE));
const SEMATTRS_RPC_JSONRPC_VERSION = ( null && (TMP_RPC_JSONRPC_VERSION));
const SEMATTRS_RPC_JSONRPC_REQUEST_ID = ( null && (TMP_RPC_JSONRPC_REQUEST_ID));
const SEMATTRS_RPC_JSONRPC_ERROR_CODE = ( null && (TMP_RPC_JSONRPC_ERROR_CODE));
const SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE = ( null && (TMP_RPC_JSONRPC_ERROR_MESSAGE));
const SEMATTRS_MESSAGE_TYPE = ( null && (TMP_MESSAGE_TYPE));
const SEMATTRS_MESSAGE_ID = ( null && (TMP_MESSAGE_ID));
const SEMATTRS_MESSAGE_COMPRESSED_SIZE = ( null && (TMP_MESSAGE_COMPRESSED_SIZE));
const SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE = ( null && (TMP_MESSAGE_UNCOMPRESSED_SIZE));
const SemanticAttributes = 
 utils_createConstMap([
    TMP_AWS_LAMBDA_INVOKED_ARN,
    TMP_DB_SYSTEM,
    TMP_DB_CONNECTION_STRING,
    TMP_DB_USER,
    TMP_DB_JDBC_DRIVER_CLASSNAME,
    TMP_DB_NAME,
    TMP_DB_STATEMENT,
    TMP_DB_OPERATION,
    TMP_DB_MSSQL_INSTANCE_NAME,
    TMP_DB_CASSANDRA_KEYSPACE,
    TMP_DB_CASSANDRA_PAGE_SIZE,
    TMP_DB_CASSANDRA_CONSISTENCY_LEVEL,
    TMP_DB_CASSANDRA_TABLE,
    TMP_DB_CASSANDRA_IDEMPOTENCE,
    TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT,
    TMP_DB_CASSANDRA_COORDINATOR_ID,
    TMP_DB_CASSANDRA_COORDINATOR_DC,
    TMP_DB_HBASE_NAMESPACE,
    TMP_DB_REDIS_DATABASE_INDEX,
    TMP_DB_MONGODB_COLLECTION,
    TMP_DB_SQL_TABLE,
    TMP_EXCEPTION_TYPE,
    TMP_EXCEPTION_MESSAGE,
    TMP_EXCEPTION_STACKTRACE,
    TMP_EXCEPTION_ESCAPED,
    TMP_FAAS_TRIGGER,
    TMP_FAAS_EXECUTION,
    TMP_FAAS_DOCUMENT_COLLECTION,
    TMP_FAAS_DOCUMENT_OPERATION,
    TMP_FAAS_DOCUMENT_TIME,
    TMP_FAAS_DOCUMENT_NAME,
    TMP_FAAS_TIME,
    TMP_FAAS_CRON,
    TMP_FAAS_COLDSTART,
    TMP_FAAS_INVOKED_NAME,
    TMP_FAAS_INVOKED_PROVIDER,
    TMP_FAAS_INVOKED_REGION,
    TMP_NET_TRANSPORT,
    TMP_NET_PEER_IP,
    TMP_NET_PEER_PORT,
    TMP_NET_PEER_NAME,
    TMP_NET_HOST_IP,
    TMP_NET_HOST_PORT,
    TMP_NET_HOST_NAME,
    TMP_NET_HOST_CONNECTION_TYPE,
    TMP_NET_HOST_CONNECTION_SUBTYPE,
    TMP_NET_HOST_CARRIER_NAME,
    TMP_NET_HOST_CARRIER_MCC,
    TMP_NET_HOST_CARRIER_MNC,
    TMP_NET_HOST_CARRIER_ICC,
    TMP_PEER_SERVICE,
    TMP_ENDUSER_ID,
    TMP_ENDUSER_ROLE,
    TMP_ENDUSER_SCOPE,
    TMP_THREAD_ID,
    TMP_THREAD_NAME,
    TMP_CODE_FUNCTION,
    TMP_CODE_NAMESPACE,
    TMP_CODE_FILEPATH,
    TMP_CODE_LINENO,
    TMP_HTTP_METHOD,
    TMP_HTTP_URL,
    TMP_HTTP_TARGET,
    TMP_HTTP_HOST,
    TMP_HTTP_SCHEME,
    TMP_HTTP_STATUS_CODE,
    TMP_HTTP_FLAVOR,
    TMP_HTTP_USER_AGENT,
    TMP_HTTP_REQUEST_CONTENT_LENGTH,
    TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED,
    TMP_HTTP_RESPONSE_CONTENT_LENGTH,
    TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED,
    TMP_HTTP_SERVER_NAME,
    TMP_HTTP_ROUTE,
    TMP_HTTP_CLIENT_IP,
    TMP_AWS_DYNAMODB_TABLE_NAMES,
    TMP_AWS_DYNAMODB_CONSUMED_CAPACITY,
    TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS,
    TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY,
    TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY,
    TMP_AWS_DYNAMODB_CONSISTENT_READ,
    TMP_AWS_DYNAMODB_PROJECTION,
    TMP_AWS_DYNAMODB_LIMIT,
    TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET,
    TMP_AWS_DYNAMODB_INDEX_NAME,
    TMP_AWS_DYNAMODB_SELECT,
    TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES,
    TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES,
    TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE,
    TMP_AWS_DYNAMODB_TABLE_COUNT,
    TMP_AWS_DYNAMODB_SCAN_FORWARD,
    TMP_AWS_DYNAMODB_SEGMENT,
    TMP_AWS_DYNAMODB_TOTAL_SEGMENTS,
    TMP_AWS_DYNAMODB_COUNT,
    TMP_AWS_DYNAMODB_SCANNED_COUNT,
    TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS,
    TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES,
    TMP_MESSAGING_SYSTEM,
    TMP_MESSAGING_DESTINATION,
    TMP_MESSAGING_DESTINATION_KIND,
    TMP_MESSAGING_TEMP_DESTINATION,
    TMP_MESSAGING_PROTOCOL,
    TMP_MESSAGING_PROTOCOL_VERSION,
    TMP_MESSAGING_URL,
    TMP_MESSAGING_MESSAGE_ID,
    TMP_MESSAGING_CONVERSATION_ID,
    TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES,
    TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES,
    TMP_MESSAGING_OPERATION,
    TMP_MESSAGING_CONSUMER_ID,
    TMP_MESSAGING_RABBITMQ_ROUTING_KEY,
    TMP_MESSAGING_KAFKA_MESSAGE_KEY,
    TMP_MESSAGING_KAFKA_CONSUMER_GROUP,
    TMP_MESSAGING_KAFKA_CLIENT_ID,
    TMP_MESSAGING_KAFKA_PARTITION,
    TMP_MESSAGING_KAFKA_TOMBSTONE,
    TMP_RPC_SYSTEM,
    TMP_RPC_SERVICE,
    TMP_RPC_METHOD,
    TMP_RPC_GRPC_STATUS_CODE,
    TMP_RPC_JSONRPC_VERSION,
    TMP_RPC_JSONRPC_REQUEST_ID,
    TMP_RPC_JSONRPC_ERROR_CODE,
    TMP_RPC_JSONRPC_ERROR_MESSAGE,
    TMP_MESSAGE_TYPE,
    TMP_MESSAGE_ID,
    TMP_MESSAGE_COMPRESSED_SIZE,
    TMP_MESSAGE_UNCOMPRESSED_SIZE,
]);
const TMP_DBSYSTEMVALUES_OTHER_SQL = 'other_sql';
const TMP_DBSYSTEMVALUES_MSSQL = 'mssql';
const TMP_DBSYSTEMVALUES_MYSQL = 'mysql';
const TMP_DBSYSTEMVALUES_ORACLE = 'oracle';
const TMP_DBSYSTEMVALUES_DB2 = 'db2';
const TMP_DBSYSTEMVALUES_POSTGRESQL = 'postgresql';
const TMP_DBSYSTEMVALUES_REDSHIFT = 'redshift';
const TMP_DBSYSTEMVALUES_HIVE = 'hive';
const TMP_DBSYSTEMVALUES_CLOUDSCAPE = 'cloudscape';
const TMP_DBSYSTEMVALUES_HSQLDB = 'hsqldb';
const TMP_DBSYSTEMVALUES_PROGRESS = 'progress';
const TMP_DBSYSTEMVALUES_MAXDB = 'maxdb';
const TMP_DBSYSTEMVALUES_HANADB = 'hanadb';
const TMP_DBSYSTEMVALUES_INGRES = 'ingres';
const TMP_DBSYSTEMVALUES_FIRSTSQL = 'firstsql';
const TMP_DBSYSTEMVALUES_EDB = 'edb';
const TMP_DBSYSTEMVALUES_CACHE = 'cache';
const TMP_DBSYSTEMVALUES_ADABAS = 'adabas';
const TMP_DBSYSTEMVALUES_FIREBIRD = 'firebird';
const TMP_DBSYSTEMVALUES_DERBY = 'derby';
const TMP_DBSYSTEMVALUES_FILEMAKER = 'filemaker';
const TMP_DBSYSTEMVALUES_INFORMIX = 'informix';
const TMP_DBSYSTEMVALUES_INSTANTDB = 'instantdb';
const TMP_DBSYSTEMVALUES_INTERBASE = 'interbase';
const TMP_DBSYSTEMVALUES_MARIADB = 'mariadb';
const TMP_DBSYSTEMVALUES_NETEZZA = 'netezza';
const TMP_DBSYSTEMVALUES_PERVASIVE = 'pervasive';
const TMP_DBSYSTEMVALUES_POINTBASE = 'pointbase';
const TMP_DBSYSTEMVALUES_SQLITE = 'sqlite';
const TMP_DBSYSTEMVALUES_SYBASE = 'sybase';
const TMP_DBSYSTEMVALUES_TERADATA = 'teradata';
const TMP_DBSYSTEMVALUES_VERTICA = 'vertica';
const TMP_DBSYSTEMVALUES_H2 = 'h2';
const TMP_DBSYSTEMVALUES_COLDFUSION = 'coldfusion';
const TMP_DBSYSTEMVALUES_CASSANDRA = 'cassandra';
const TMP_DBSYSTEMVALUES_HBASE = 'hbase';
const TMP_DBSYSTEMVALUES_MONGODB = 'mongodb';
const TMP_DBSYSTEMVALUES_REDIS = 'redis';
const TMP_DBSYSTEMVALUES_COUCHBASE = 'couchbase';
const TMP_DBSYSTEMVALUES_COUCHDB = 'couchdb';
const TMP_DBSYSTEMVALUES_COSMOSDB = 'cosmosdb';
const TMP_DBSYSTEMVALUES_DYNAMODB = 'dynamodb';
const TMP_DBSYSTEMVALUES_NEO4J = 'neo4j';
const TMP_DBSYSTEMVALUES_GEODE = 'geode';
const TMP_DBSYSTEMVALUES_ELASTICSEARCH = 'elasticsearch';
const TMP_DBSYSTEMVALUES_MEMCACHED = 'memcached';
const TMP_DBSYSTEMVALUES_COCKROACHDB = 'cockroachdb';
const DBSYSTEMVALUES_OTHER_SQL = ( null && (TMP_DBSYSTEMVALUES_OTHER_SQL));
const DBSYSTEMVALUES_MSSQL = ( null && (TMP_DBSYSTEMVALUES_MSSQL));
const DBSYSTEMVALUES_MYSQL = ( null && (TMP_DBSYSTEMVALUES_MYSQL));
const DBSYSTEMVALUES_ORACLE = ( null && (TMP_DBSYSTEMVALUES_ORACLE));
const DBSYSTEMVALUES_DB2 = ( null && (TMP_DBSYSTEMVALUES_DB2));
const DBSYSTEMVALUES_POSTGRESQL = ( null && (TMP_DBSYSTEMVALUES_POSTGRESQL));
const DBSYSTEMVALUES_REDSHIFT = ( null && (TMP_DBSYSTEMVALUES_REDSHIFT));
const DBSYSTEMVALUES_HIVE = ( null && (TMP_DBSYSTEMVALUES_HIVE));
const DBSYSTEMVALUES_CLOUDSCAPE = ( null && (TMP_DBSYSTEMVALUES_CLOUDSCAPE));
const DBSYSTEMVALUES_HSQLDB = ( null && (TMP_DBSYSTEMVALUES_HSQLDB));
const DBSYSTEMVALUES_PROGRESS = ( null && (TMP_DBSYSTEMVALUES_PROGRESS));
const DBSYSTEMVALUES_MAXDB = ( null && (TMP_DBSYSTEMVALUES_MAXDB));
const DBSYSTEMVALUES_HANADB = ( null && (TMP_DBSYSTEMVALUES_HANADB));
const DBSYSTEMVALUES_INGRES = ( null && (TMP_DBSYSTEMVALUES_INGRES));
const DBSYSTEMVALUES_FIRSTSQL = ( null && (TMP_DBSYSTEMVALUES_FIRSTSQL));
const DBSYSTEMVALUES_EDB = ( null && (TMP_DBSYSTEMVALUES_EDB));
const DBSYSTEMVALUES_CACHE = ( null && (TMP_DBSYSTEMVALUES_CACHE));
const DBSYSTEMVALUES_ADABAS = ( null && (TMP_DBSYSTEMVALUES_ADABAS));
const DBSYSTEMVALUES_FIREBIRD = ( null && (TMP_DBSYSTEMVALUES_FIREBIRD));
const DBSYSTEMVALUES_DERBY = ( null && (TMP_DBSYSTEMVALUES_DERBY));
const DBSYSTEMVALUES_FILEMAKER = ( null && (TMP_DBSYSTEMVALUES_FILEMAKER));
const DBSYSTEMVALUES_INFORMIX = ( null && (TMP_DBSYSTEMVALUES_INFORMIX));
const DBSYSTEMVALUES_INSTANTDB = ( null && (TMP_DBSYSTEMVALUES_INSTANTDB));
const DBSYSTEMVALUES_INTERBASE = ( null && (TMP_DBSYSTEMVALUES_INTERBASE));
const DBSYSTEMVALUES_MARIADB = ( null && (TMP_DBSYSTEMVALUES_MARIADB));
const DBSYSTEMVALUES_NETEZZA = ( null && (TMP_DBSYSTEMVALUES_NETEZZA));
const DBSYSTEMVALUES_PERVASIVE = ( null && (TMP_DBSYSTEMVALUES_PERVASIVE));
const DBSYSTEMVALUES_POINTBASE = ( null && (TMP_DBSYSTEMVALUES_POINTBASE));
const DBSYSTEMVALUES_SQLITE = ( null && (TMP_DBSYSTEMVALUES_SQLITE));
const DBSYSTEMVALUES_SYBASE = ( null && (TMP_DBSYSTEMVALUES_SYBASE));
const DBSYSTEMVALUES_TERADATA = ( null && (TMP_DBSYSTEMVALUES_TERADATA));
const DBSYSTEMVALUES_VERTICA = ( null && (TMP_DBSYSTEMVALUES_VERTICA));
const DBSYSTEMVALUES_H2 = ( null && (TMP_DBSYSTEMVALUES_H2));
const DBSYSTEMVALUES_COLDFUSION = ( null && (TMP_DBSYSTEMVALUES_COLDFUSION));
const DBSYSTEMVALUES_CASSANDRA = ( null && (TMP_DBSYSTEMVALUES_CASSANDRA));
const DBSYSTEMVALUES_HBASE = ( null && (TMP_DBSYSTEMVALUES_HBASE));
const DBSYSTEMVALUES_MONGODB = ( null && (TMP_DBSYSTEMVALUES_MONGODB));
const DBSYSTEMVALUES_REDIS = ( null && (TMP_DBSYSTEMVALUES_REDIS));
const DBSYSTEMVALUES_COUCHBASE = ( null && (TMP_DBSYSTEMVALUES_COUCHBASE));
const DBSYSTEMVALUES_COUCHDB = ( null && (TMP_DBSYSTEMVALUES_COUCHDB));
const DBSYSTEMVALUES_COSMOSDB = ( null && (TMP_DBSYSTEMVALUES_COSMOSDB));
const DBSYSTEMVALUES_DYNAMODB = ( null && (TMP_DBSYSTEMVALUES_DYNAMODB));
const DBSYSTEMVALUES_NEO4J = ( null && (TMP_DBSYSTEMVALUES_NEO4J));
const DBSYSTEMVALUES_GEODE = ( null && (TMP_DBSYSTEMVALUES_GEODE));
const DBSYSTEMVALUES_ELASTICSEARCH = ( null && (TMP_DBSYSTEMVALUES_ELASTICSEARCH));
const DBSYSTEMVALUES_MEMCACHED = ( null && (TMP_DBSYSTEMVALUES_MEMCACHED));
const DBSYSTEMVALUES_COCKROACHDB = ( null && (TMP_DBSYSTEMVALUES_COCKROACHDB));
const DbSystemValues = 
 utils_createConstMap([
    TMP_DBSYSTEMVALUES_OTHER_SQL,
    TMP_DBSYSTEMVALUES_MSSQL,
    TMP_DBSYSTEMVALUES_MYSQL,
    TMP_DBSYSTEMVALUES_ORACLE,
    TMP_DBSYSTEMVALUES_DB2,
    TMP_DBSYSTEMVALUES_POSTGRESQL,
    TMP_DBSYSTEMVALUES_REDSHIFT,
    TMP_DBSYSTEMVALUES_HIVE,
    TMP_DBSYSTEMVALUES_CLOUDSCAPE,
    TMP_DBSYSTEMVALUES_HSQLDB,
    TMP_DBSYSTEMVALUES_PROGRESS,
    TMP_DBSYSTEMVALUES_MAXDB,
    TMP_DBSYSTEMVALUES_HANADB,
    TMP_DBSYSTEMVALUES_INGRES,
    TMP_DBSYSTEMVALUES_FIRSTSQL,
    TMP_DBSYSTEMVALUES_EDB,
    TMP_DBSYSTEMVALUES_CACHE,
    TMP_DBSYSTEMVALUES_ADABAS,
    TMP_DBSYSTEMVALUES_FIREBIRD,
    TMP_DBSYSTEMVALUES_DERBY,
    TMP_DBSYSTEMVALUES_FILEMAKER,
    TMP_DBSYSTEMVALUES_INFORMIX,
    TMP_DBSYSTEMVALUES_INSTANTDB,
    TMP_DBSYSTEMVALUES_INTERBASE,
    TMP_DBSYSTEMVALUES_MARIADB,
    TMP_DBSYSTEMVALUES_NETEZZA,
    TMP_DBSYSTEMVALUES_PERVASIVE,
    TMP_DBSYSTEMVALUES_POINTBASE,
    TMP_DBSYSTEMVALUES_SQLITE,
    TMP_DBSYSTEMVALUES_SYBASE,
    TMP_DBSYSTEMVALUES_TERADATA,
    TMP_DBSYSTEMVALUES_VERTICA,
    TMP_DBSYSTEMVALUES_H2,
    TMP_DBSYSTEMVALUES_COLDFUSION,
    TMP_DBSYSTEMVALUES_CASSANDRA,
    TMP_DBSYSTEMVALUES_HBASE,
    TMP_DBSYSTEMVALUES_MONGODB,
    TMP_DBSYSTEMVALUES_REDIS,
    TMP_DBSYSTEMVALUES_COUCHBASE,
    TMP_DBSYSTEMVALUES_COUCHDB,
    TMP_DBSYSTEMVALUES_COSMOSDB,
    TMP_DBSYSTEMVALUES_DYNAMODB,
    TMP_DBSYSTEMVALUES_NEO4J,
    TMP_DBSYSTEMVALUES_GEODE,
    TMP_DBSYSTEMVALUES_ELASTICSEARCH,
    TMP_DBSYSTEMVALUES_MEMCACHED,
    TMP_DBSYSTEMVALUES_COCKROACHDB,
]);
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL = 'all';
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = 'each_quorum';
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = 'quorum';
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = 'local_quorum';
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE = 'one';
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO = 'two';
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE = 'three';
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = 'local_one';
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY = 'any';
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = 'serial';
const TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = 'local_serial';
const DBCASSANDRACONSISTENCYLEVELVALUES_ALL = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL));
const DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM));
const DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM));
const DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM));
const DBCASSANDRACONSISTENCYLEVELVALUES_ONE = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE));
const DBCASSANDRACONSISTENCYLEVELVALUES_TWO = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO));
const DBCASSANDRACONSISTENCYLEVELVALUES_THREE = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE));
const DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE));
const DBCASSANDRACONSISTENCYLEVELVALUES_ANY = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY));
const DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL));
const DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = ( null && (TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL));
const DbCassandraConsistencyLevelValues = 
 utils_createConstMap([
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL,
]);
const TMP_FAASTRIGGERVALUES_DATASOURCE = 'datasource';
const TMP_FAASTRIGGERVALUES_HTTP = 'http';
const TMP_FAASTRIGGERVALUES_PUBSUB = 'pubsub';
const TMP_FAASTRIGGERVALUES_TIMER = 'timer';
const TMP_FAASTRIGGERVALUES_OTHER = 'other';
const FAASTRIGGERVALUES_DATASOURCE = ( null && (TMP_FAASTRIGGERVALUES_DATASOURCE));
const FAASTRIGGERVALUES_HTTP = ( null && (TMP_FAASTRIGGERVALUES_HTTP));
const FAASTRIGGERVALUES_PUBSUB = ( null && (TMP_FAASTRIGGERVALUES_PUBSUB));
const FAASTRIGGERVALUES_TIMER = ( null && (TMP_FAASTRIGGERVALUES_TIMER));
const FAASTRIGGERVALUES_OTHER = ( null && (TMP_FAASTRIGGERVALUES_OTHER));
const FaasTriggerValues = 
 utils_createConstMap([
    TMP_FAASTRIGGERVALUES_DATASOURCE,
    TMP_FAASTRIGGERVALUES_HTTP,
    TMP_FAASTRIGGERVALUES_PUBSUB,
    TMP_FAASTRIGGERVALUES_TIMER,
    TMP_FAASTRIGGERVALUES_OTHER,
]);
const TMP_FAASDOCUMENTOPERATIONVALUES_INSERT = 'insert';
const TMP_FAASDOCUMENTOPERATIONVALUES_EDIT = 'edit';
const TMP_FAASDOCUMENTOPERATIONVALUES_DELETE = 'delete';
const FAASDOCUMENTOPERATIONVALUES_INSERT = ( null && (TMP_FAASDOCUMENTOPERATIONVALUES_INSERT));
const FAASDOCUMENTOPERATIONVALUES_EDIT = ( null && (TMP_FAASDOCUMENTOPERATIONVALUES_EDIT));
const FAASDOCUMENTOPERATIONVALUES_DELETE = ( null && (TMP_FAASDOCUMENTOPERATIONVALUES_DELETE));
const FaasDocumentOperationValues = 
 utils_createConstMap([
    TMP_FAASDOCUMENTOPERATIONVALUES_INSERT,
    TMP_FAASDOCUMENTOPERATIONVALUES_EDIT,
    TMP_FAASDOCUMENTOPERATIONVALUES_DELETE,
]);
const TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = 'alibaba_cloud';
const TMP_FAASINVOKEDPROVIDERVALUES_AWS = 'aws';
const TMP_FAASINVOKEDPROVIDERVALUES_AZURE = 'azure';
const TMP_FAASINVOKEDPROVIDERVALUES_GCP = 'gcp';
const FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = ( null && (TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD));
const FAASINVOKEDPROVIDERVALUES_AWS = ( null && (TMP_FAASINVOKEDPROVIDERVALUES_AWS));
const FAASINVOKEDPROVIDERVALUES_AZURE = ( null && (TMP_FAASINVOKEDPROVIDERVALUES_AZURE));
const FAASINVOKEDPROVIDERVALUES_GCP = ( null && (TMP_FAASINVOKEDPROVIDERVALUES_GCP));
const FaasInvokedProviderValues = 
 utils_createConstMap([
    TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD,
    TMP_FAASINVOKEDPROVIDERVALUES_AWS,
    TMP_FAASINVOKEDPROVIDERVALUES_AZURE,
    TMP_FAASINVOKEDPROVIDERVALUES_GCP,
]);
const TMP_NETTRANSPORTVALUES_IP_TCP = 'ip_tcp';
const TMP_NETTRANSPORTVALUES_IP_UDP = 'ip_udp';
const TMP_NETTRANSPORTVALUES_IP = 'ip';
const TMP_NETTRANSPORTVALUES_UNIX = 'unix';
const TMP_NETTRANSPORTVALUES_PIPE = 'pipe';
const TMP_NETTRANSPORTVALUES_INPROC = 'inproc';
const TMP_NETTRANSPORTVALUES_OTHER = 'other';
const NETTRANSPORTVALUES_IP_TCP = ( null && (TMP_NETTRANSPORTVALUES_IP_TCP));
const NETTRANSPORTVALUES_IP_UDP = ( null && (TMP_NETTRANSPORTVALUES_IP_UDP));
const NETTRANSPORTVALUES_IP = ( null && (TMP_NETTRANSPORTVALUES_IP));
const NETTRANSPORTVALUES_UNIX = ( null && (TMP_NETTRANSPORTVALUES_UNIX));
const NETTRANSPORTVALUES_PIPE = ( null && (TMP_NETTRANSPORTVALUES_PIPE));
const NETTRANSPORTVALUES_INPROC = ( null && (TMP_NETTRANSPORTVALUES_INPROC));
const NETTRANSPORTVALUES_OTHER = ( null && (TMP_NETTRANSPORTVALUES_OTHER));
const NetTransportValues = 
 utils_createConstMap([
    TMP_NETTRANSPORTVALUES_IP_TCP,
    TMP_NETTRANSPORTVALUES_IP_UDP,
    TMP_NETTRANSPORTVALUES_IP,
    TMP_NETTRANSPORTVALUES_UNIX,
    TMP_NETTRANSPORTVALUES_PIPE,
    TMP_NETTRANSPORTVALUES_INPROC,
    TMP_NETTRANSPORTVALUES_OTHER,
]);
const TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI = 'wifi';
const TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED = 'wired';
const TMP_NETHOSTCONNECTIONTYPEVALUES_CELL = 'cell';
const TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = 'unavailable';
const TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = 'unknown';
const NETHOSTCONNECTIONTYPEVALUES_WIFI = ( null && (TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI));
const NETHOSTCONNECTIONTYPEVALUES_WIRED = ( null && (TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED));
const NETHOSTCONNECTIONTYPEVALUES_CELL = ( null && (TMP_NETHOSTCONNECTIONTYPEVALUES_CELL));
const NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = ( null && (TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE));
const NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = ( null && (TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN));
const NetHostConnectionTypeValues = 
 utils_createConstMap([
    TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI,
    TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED,
    TMP_NETHOSTCONNECTIONTYPEVALUES_CELL,
    TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE,
    TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN,
]);
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = 'gprs';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = 'edge';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = 'umts';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = 'cdma';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = 'evdo_0';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = 'evdo_a';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = 'cdma2000_1xrtt';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = 'hsdpa';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = 'hsupa';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = 'hspa';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = 'iden';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = 'evdo_b';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE = 'lte';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = 'ehrpd';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = 'hspap';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM = 'gsm';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = 'td_scdma';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = 'iwlan';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR = 'nr';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = 'nrnsa';
const TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = 'lte_ca';
const NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS));
const NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE));
const NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS));
const NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA));
const NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0));
const NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A));
const NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT));
const NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA));
const NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA));
const NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA));
const NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN));
const NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B));
const NETHOSTCONNECTIONSUBTYPEVALUES_LTE = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE));
const NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD));
const NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP));
const NETHOSTCONNECTIONSUBTYPEVALUES_GSM = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM));
const NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA));
const NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN));
const NETHOSTCONNECTIONSUBTYPEVALUES_NR = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR));
const NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA));
const NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = ( null && (TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA));
const NetHostConnectionSubtypeValues = 
 utils_createConstMap([
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA,
]);
const TMP_HTTPFLAVORVALUES_HTTP_1_0 = '1.0';
const TMP_HTTPFLAVORVALUES_HTTP_1_1 = '1.1';
const TMP_HTTPFLAVORVALUES_HTTP_2_0 = '2.0';
const TMP_HTTPFLAVORVALUES_SPDY = 'SPDY';
const TMP_HTTPFLAVORVALUES_QUIC = 'QUIC';
const HTTPFLAVORVALUES_HTTP_1_0 = ( null && (TMP_HTTPFLAVORVALUES_HTTP_1_0));
const HTTPFLAVORVALUES_HTTP_1_1 = ( null && (TMP_HTTPFLAVORVALUES_HTTP_1_1));
const HTTPFLAVORVALUES_HTTP_2_0 = ( null && (TMP_HTTPFLAVORVALUES_HTTP_2_0));
const HTTPFLAVORVALUES_SPDY = ( null && (TMP_HTTPFLAVORVALUES_SPDY));
const HTTPFLAVORVALUES_QUIC = ( null && (TMP_HTTPFLAVORVALUES_QUIC));
const HttpFlavorValues = {
    HTTP_1_0: TMP_HTTPFLAVORVALUES_HTTP_1_0,
    HTTP_1_1: TMP_HTTPFLAVORVALUES_HTTP_1_1,
    HTTP_2_0: TMP_HTTPFLAVORVALUES_HTTP_2_0,
    SPDY: TMP_HTTPFLAVORVALUES_SPDY,
    QUIC: TMP_HTTPFLAVORVALUES_QUIC,
};
const TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE = 'queue';
const TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC = 'topic';
const MESSAGINGDESTINATIONKINDVALUES_QUEUE = ( null && (TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE));
const MESSAGINGDESTINATIONKINDVALUES_TOPIC = ( null && (TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC));
const MessagingDestinationKindValues = 
 utils_createConstMap([
    TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE,
    TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC,
]);
const TMP_MESSAGINGOPERATIONVALUES_RECEIVE = 'receive';
const TMP_MESSAGINGOPERATIONVALUES_PROCESS = 'process';
const MESSAGINGOPERATIONVALUES_RECEIVE = ( null && (TMP_MESSAGINGOPERATIONVALUES_RECEIVE));
const MESSAGINGOPERATIONVALUES_PROCESS = ( null && (TMP_MESSAGINGOPERATIONVALUES_PROCESS));
const MessagingOperationValues = 
 utils_createConstMap([
    TMP_MESSAGINGOPERATIONVALUES_RECEIVE,
    TMP_MESSAGINGOPERATIONVALUES_PROCESS,
]);
const TMP_RPCGRPCSTATUSCODEVALUES_OK = 0;
const TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED = 1;
const TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN = 2;
const TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = 3;
const TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = 4;
const TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND = 5;
const TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = 6;
const TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = 7;
const TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = 8;
const TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = 9;
const TMP_RPCGRPCSTATUSCODEVALUES_ABORTED = 10;
const TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = 11;
const TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = 12;
const TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL = 13;
const TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = 14;
const TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS = 15;
const TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = 16;
const RPCGRPCSTATUSCODEVALUES_OK = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_OK));
const RPCGRPCSTATUSCODEVALUES_CANCELLED = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED));
const RPCGRPCSTATUSCODEVALUES_UNKNOWN = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN));
const RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT));
const RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED));
const RPCGRPCSTATUSCODEVALUES_NOT_FOUND = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND));
const RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS));
const RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED));
const RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED));
const RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION));
const RPCGRPCSTATUSCODEVALUES_ABORTED = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_ABORTED));
const RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE));
const RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED));
const RPCGRPCSTATUSCODEVALUES_INTERNAL = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL));
const RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE));
const RPCGRPCSTATUSCODEVALUES_DATA_LOSS = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS));
const RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = ( null && (TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED));
const RpcGrpcStatusCodeValues = {
    OK: TMP_RPCGRPCSTATUSCODEVALUES_OK,
    CANCELLED: TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED,
    UNKNOWN: TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN,
    INVALID_ARGUMENT: TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT,
    DEADLINE_EXCEEDED: TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED,
    NOT_FOUND: TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND,
    ALREADY_EXISTS: TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS,
    PERMISSION_DENIED: TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED,
    RESOURCE_EXHAUSTED: TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED,
    FAILED_PRECONDITION: TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION,
    ABORTED: TMP_RPCGRPCSTATUSCODEVALUES_ABORTED,
    OUT_OF_RANGE: TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE,
    UNIMPLEMENTED: TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED,
    INTERNAL: TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL,
    UNAVAILABLE: TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE,
    DATA_LOSS: TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS,
    UNAUTHENTICATED: TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED,
};
const TMP_MESSAGETYPEVALUES_SENT = 'SENT';
const TMP_MESSAGETYPEVALUES_RECEIVED = 'RECEIVED';
const MESSAGETYPEVALUES_SENT = ( null && (TMP_MESSAGETYPEVALUES_SENT));
const MESSAGETYPEVALUES_RECEIVED = ( null && (TMP_MESSAGETYPEVALUES_RECEIVED));
const MessageTypeValues = 
 utils_createConstMap([
    TMP_MESSAGETYPEVALUES_SENT,
    TMP_MESSAGETYPEVALUES_RECEIVED,
]);
;
const ExceptionEventName = 'exception';
;




class SpanImpl {
    _spanContext;
    kind;
    parentSpanContext;
    attributes = {};
    links = [];
    events = [];
    startTime;
    resource;
    instrumentationScope;
    _droppedAttributesCount = 0;
    _droppedEventsCount = 0;
    _droppedLinksCount = 0;
    name;
    status = {
        code: SpanStatusCode.UNSET,
    };
    endTime = [0, 0];
    _ended = false;
    _duration = [-1, -1];
    _spanProcessor;
    _spanLimits;
    _attributeValueLengthLimit;
    _performanceStartTime;
    _performanceOffset;
    _startTimeProvided;
    constructor(opts) {
        const now = Date.now();
        this._spanContext = opts.spanContext;
        this._performanceStartTime = otperformance.now();
        this._performanceOffset =
            now - (this._performanceStartTime + getTimeOrigin());
        this._startTimeProvided = opts.startTime != null;
        this._spanLimits = opts.spanLimits;
        this._attributeValueLengthLimit =
            this._spanLimits.attributeValueLengthLimit || 0;
        this._spanProcessor = opts.spanProcessor;
        this.name = opts.name;
        this.parentSpanContext = opts.parentSpanContext;
        this.kind = opts.kind;
        this.links = opts.links || [];
        this.startTime = this._getTime(opts.startTime ?? now);
        this.resource = opts.resource;
        this.instrumentationScope = opts.scope;
        if (opts.attributes != null) {
            this.setAttributes(opts.attributes);
        }
        this._spanProcessor.onStart(this, opts.context);
    }
    spanContext() {
        return this._spanContext;
    }
    setAttribute(key, value) {
        if (value == null || this._isSpanEnded())
            return this;
        if (key.length === 0) {
            diag.warn(`Invalid attribute key: ${key}`);
            return this;
        }
        if (!isAttributeValue(value)) {
            diag.warn(`Invalid attribute value set for key: ${key}`);
            return this;
        }
        const { attributeCountLimit } = this._spanLimits;
        if (attributeCountLimit !== undefined &&
            Object.keys(this.attributes).length >= attributeCountLimit &&
            !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        return this;
    }
    setAttributes(attributes) {
        for (const [k, v] of Object.entries(attributes)) {
            this.setAttribute(k, v);
        }
        return this;
    }
    addEvent(name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded())
            return this;
        const { eventCountLimit } = this._spanLimits;
        if (eventCountLimit === 0) {
            diag.warn('No events allowed.');
            this._droppedEventsCount++;
            return this;
        }
        if (eventCountLimit !== undefined &&
            this.events.length >= eventCountLimit) {
            if (this._droppedEventsCount === 0) {
                diag.debug('Dropping extra events.');
            }
            this.events.shift();
            this._droppedEventsCount++;
        }
        if (isTimeInput(attributesOrStartTime)) {
            if (!isTimeInput(timeStamp)) {
                timeStamp = attributesOrStartTime;
            }
            attributesOrStartTime = undefined;
        }
        const attributes = sanitizeAttributes(attributesOrStartTime);
        this.events.push({
            name,
            attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: 0,
        });
        return this;
    }
    addLink(link) {
        this.links.push(link);
        return this;
    }
    addLinks(links) {
        this.links.push(...links);
        return this;
    }
    setStatus(status) {
        if (this._isSpanEnded())
            return this;
        this.status = { ...status };
        if (this.status.message != null && typeof status.message !== 'string') {
            diag.warn(`Dropping invalid status.message of type '${typeof status.message}', expected 'string'`);
            delete this.status.message;
        }
        return this;
    }
    updateName(name) {
        if (this._isSpanEnded())
            return this;
        this.name = name;
        return this;
    }
    end(endTime) {
        if (this._isSpanEnded()) {
            diag.error(`${this.name} ${this._spanContext.traceId}-${this._spanContext.spanId} - You can only call end() on a span once.`);
            return;
        }
        this._ended = true;
        this.endTime = this._getTime(endTime);
        this._duration = hrTimeDuration(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            diag.warn('Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.', this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [0, 0];
        }
        if (this._droppedEventsCount > 0) {
            diag.warn(`Dropped ${this._droppedEventsCount} events because eventCountLimit reached`);
        }
        this._spanProcessor.onEnd(this);
    }
    _getTime(inp) {
        if (typeof inp === 'number' && inp <= otperformance.now()) {
            return hrTime(inp + this._performanceOffset);
        }
        if (typeof inp === 'number') {
            return millisToHrTime(inp);
        }
        if (inp instanceof Date) {
            return millisToHrTime(inp.getTime());
        }
        if (isTimeInputHrTime(inp)) {
            return inp;
        }
        if (this._startTimeProvided) {
            return millisToHrTime(Date.now());
        }
        const msDuration = otperformance.now() - this._performanceStartTime;
        return addHrTimes(this.startTime, millisToHrTime(msDuration));
    }
    isRecording() {
        return this._ended === false;
    }
    recordException(exception, time) {
        const attributes = {};
        if (typeof exception === 'string') {
            attributes[SEMATTRS_EXCEPTION_MESSAGE] = exception;
        }
        else if (exception) {
            if (exception.code) {
                attributes[SEMATTRS_EXCEPTION_TYPE] = exception.code.toString();
            }
            else if (exception.name) {
                attributes[SEMATTRS_EXCEPTION_TYPE] = exception.name;
            }
            if (exception.message) {
                attributes[SEMATTRS_EXCEPTION_MESSAGE] = exception.message;
            }
            if (exception.stack) {
                attributes[SEMATTRS_EXCEPTION_STACKTRACE] = exception.stack;
            }
        }
        if (attributes[SEMATTRS_EXCEPTION_TYPE] ||
            attributes[SEMATTRS_EXCEPTION_MESSAGE]) {
            this.addEvent(ExceptionEventName, attributes, time);
        }
        else {
            diag.warn(`Failed to record an exception ${exception}`);
        }
    }
    get duration() {
        return this._duration;
    }
    get ended() {
        return this._ended;
    }
    get droppedAttributesCount() {
        return this._droppedAttributesCount;
    }
    get droppedEventsCount() {
        return this._droppedEventsCount;
    }
    get droppedLinksCount() {
        return this._droppedLinksCount;
    }
    _isSpanEnded() {
        if (this._ended) {
            const error = new Error(`Operation attempted on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`);
            diag.warn(`Cannot execute the operation on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`, error);
        }
        return this._ended;
    }
    _truncateToLimitUtil(value, limit) {
        if (value.length <= limit) {
            return value;
        }
        return value.substring(0, limit);
    }
    _truncateToSize(value) {
        const limit = this._attributeValueLengthLimit;
        if (limit <= 0) {
            diag.warn(`Attribute value limit must be positive, got ${limit}`);
            return value;
        }
        if (typeof value === 'string') {
            return this._truncateToLimitUtil(value, limit);
        }
        if (Array.isArray(value)) {
            return value.map(val => typeof val === 'string' ? this._truncateToLimitUtil(val, limit) : val);
        }
        return value;
    }
}
;
function getStringFromEnv(_) {
    return undefined;
}
function getBooleanFromEnv(_) {
    return undefined;
}
function getNumberFromEnv(_) {
    return undefined;
}
function getStringListFromEnv(_) {
    return undefined;
}
;
var Sampler_SamplingDecision;
(function (SamplingDecision) {
    SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})(Sampler_SamplingDecision || (Sampler_SamplingDecision = {}));
;

class AlwaysOffSampler {
    shouldSample() {
        return {
            decision: Sampler_SamplingDecision.NOT_RECORD,
        };
    }
    toString() {
        return 'AlwaysOffSampler';
    }
}
;

class AlwaysOnSampler {
    shouldSample() {
        return {
            decision: Sampler_SamplingDecision.RECORD_AND_SAMPLED,
        };
    }
    toString() {
        return 'AlwaysOnSampler';
    }
}
;

function loggingErrorHandler() {
    return (ex) => {
        diag.error(stringifyException(ex));
    };
}
function stringifyException(ex) {
    if (typeof ex === 'string') {
        return ex;
    }
    else {
        return JSON.stringify(flattenException(ex));
    }
}
function flattenException(ex) {
    const result = {};
    let current = ex;
    while (current !== null) {
        Object.getOwnPropertyNames(current).forEach(propertyName => {
            if (result[propertyName])
                return;
            const value = current[propertyName];
            if (value) {
                result[propertyName] = String(value);
            }
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}
;

let delegateHandler = loggingErrorHandler();
function setGlobalErrorHandler(handler) {
    delegateHandler = handler;
}
function globalErrorHandler(ex) {
    try {
        delegateHandler(ex);
    }
    catch { } 
}
;




class ParentBasedSampler {
    _root;
    _remoteParentSampled;
    _remoteParentNotSampled;
    _localParentSampled;
    _localParentNotSampled;
    constructor(config) {
        this._root = config.root;
        if (!this._root) {
            globalErrorHandler(new Error('ParentBasedSampler must have a root sampler configured'));
            this._root = new AlwaysOnSampler();
        }
        this._remoteParentSampled =
            config.remoteParentSampled ?? new AlwaysOnSampler();
        this._remoteParentNotSampled =
            config.remoteParentNotSampled ?? new AlwaysOffSampler();
        this._localParentSampled =
            config.localParentSampled ?? new AlwaysOnSampler();
        this._localParentNotSampled =
            config.localParentNotSampled ?? new AlwaysOffSampler();
    }
    shouldSample(context, traceId, spanName, spanKind, attributes, links) {
        const parentContext = trace.getSpanContext(context);
        if (!parentContext || !isSpanContextValid(parentContext)) {
            return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & TraceFlags.SAMPLED) {
                return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            }
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & TraceFlags.SAMPLED) {
            return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    }
    toString() {
        return `ParentBased{root=${this._root.toString()}, remoteParentSampled=${this._remoteParentSampled.toString()}, remoteParentNotSampled=${this._remoteParentNotSampled.toString()}, localParentSampled=${this._localParentSampled.toString()}, localParentNotSampled=${this._localParentNotSampled.toString()}}`;
    }
}
;


class TraceIdRatioBasedSampler {
    _ratio;
    _upperBound;
    constructor(_ratio = 0) {
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    shouldSample(context, traceId) {
        return {
            decision: isValidTraceId(traceId) && this._accumulate(traceId) < this._upperBound
                ? Sampler_SamplingDecision.RECORD_AND_SAMPLED
                : Sampler_SamplingDecision.NOT_RECORD,
        };
    }
    toString() {
        return `TraceIdRatioBased{${this._ratio}}`;
    }
    _normalize(ratio) {
        if (typeof ratio !== 'number' || isNaN(ratio))
            return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    }
    _accumulate(traceId) {
        let accumulation = 0;
        for (let i = 0; i < traceId.length / 8; i++) {
            const pos = i * 8;
            const part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    }
}
;






const DEFAULT_RATIO = 1;
function loadDefaultConfig() {
    return {
        sampler: buildSamplerFromEnv(),
        forceFlushTimeoutMillis: 30000,
        generalLimits: {
            attributeValueLengthLimit: getNumberFromEnv('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: getNumberFromEnv('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? 128,
        },
        spanLimits: {
            attributeValueLengthLimit: getNumberFromEnv('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: getNumberFromEnv('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? 128,
            linkCountLimit: getNumberFromEnv('OTEL_SPAN_LINK_COUNT_LIMIT') ?? 128,
            eventCountLimit: getNumberFromEnv('OTEL_SPAN_EVENT_COUNT_LIMIT') ?? 128,
            attributePerEventCountLimit: getNumberFromEnv('OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT') ?? 128,
            attributePerLinkCountLimit: getNumberFromEnv('OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT') ?? 128,
        },
    };
}
function buildSamplerFromEnv() {
    const sampler = getStringFromEnv('OTEL_TRACES_SAMPLER') ??
        "parentbased_always_on" ;
    switch (sampler) {
        case "always_on" :
            return new AlwaysOnSampler();
        case "always_off" :
            return new AlwaysOffSampler();
        case "parentbased_always_on" :
            return new ParentBasedSampler({
                root: new AlwaysOnSampler(),
            });
        case "parentbased_always_off" :
            return new ParentBasedSampler({
                root: new AlwaysOffSampler(),
            });
        case "traceidratio" :
            return new TraceIdRatioBasedSampler(getSamplerProbabilityFromEnv());
        case "parentbased_traceidratio" :
            return new ParentBasedSampler({
                root: new TraceIdRatioBasedSampler(getSamplerProbabilityFromEnv()),
            });
        default:
            diag.error(`OTEL_TRACES_SAMPLER value "${sampler}" invalid, defaulting to "${"parentbased_always_on" /* TracesSamplerValues.ParentBasedAlwaysOn */}".`);
            return new ParentBasedSampler({
                root: new AlwaysOnSampler(),
            });
    }
}
function getSamplerProbabilityFromEnv() {
    const probability = getNumberFromEnv('OTEL_TRACES_SAMPLER_ARG');
    if (probability == null) {
        diag.error(`OTEL_TRACES_SAMPLER_ARG is blank, defaulting to ${DEFAULT_RATIO}.`);
        return DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        diag.error(`OTEL_TRACES_SAMPLER_ARG=${probability} was given, but it is out of range ([0..1]), defaulting to ${DEFAULT_RATIO}.`);
        return DEFAULT_RATIO;
    }
    return probability;
}
;


const DEFAULT_ATTRIBUTE_COUNT_LIMIT = 128;
const DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT = Infinity;
function mergeConfig(userConfig) {
    const perInstanceDefaults = {
        sampler: buildSamplerFromEnv(),
    };
    const DEFAULT_CONFIG = loadDefaultConfig();
    const target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function reconfigureLimits(userConfig) {
    const spanLimits = Object.assign({}, userConfig.spanLimits);
    spanLimits.attributeCountLimit =
        userConfig.spanLimits?.attributeCountLimit ??
            userConfig.generalLimits?.attributeCountLimit ??
            getNumberFromEnv('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ??
            getNumberFromEnv('OTEL_ATTRIBUTE_COUNT_LIMIT') ??
            DEFAULT_ATTRIBUTE_COUNT_LIMIT;
    spanLimits.attributeValueLengthLimit =
        userConfig.spanLimits?.attributeValueLengthLimit ??
            userConfig.generalLimits?.attributeValueLengthLimit ??
            getNumberFromEnv('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ??
            getNumberFromEnv('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ??
            DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT;
    return Object.assign({}, userConfig, { spanLimits });
}
;
const SPAN_ID_BYTES = 8;
const TRACE_ID_BYTES = 16;
class RandomIdGenerator {
    generateTraceId = getIdGenerator(TRACE_ID_BYTES);
    generateSpanId = getIdGenerator(SPAN_ID_BYTES);
}
const SHARED_CHAR_CODES_ARRAY = Array(32);
function getIdGenerator(bytes) {
    return function generateId() {
        for (let i = 0; i < bytes * 2; i++) {
            SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            if (SHARED_CHAR_CODES_ARRAY[i] >= 58) {
                SHARED_CHAR_CODES_ARRAY[i] += 39;
            }
        }
        return String.fromCharCode.apply(null, SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}
;





class Tracer {
    _sampler;
    _generalLimits;
    _spanLimits;
    _idGenerator;
    instrumentationScope;
    _resource;
    _spanProcessor;
    constructor(instrumentationScope, config, resource, spanProcessor) {
        const localConfig = mergeConfig(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new RandomIdGenerator();
        this._resource = resource;
        this._spanProcessor = spanProcessor;
        this.instrumentationScope = instrumentationScope;
    }
    startSpan(name, options = {}, context = context_api_context.active()) {
        if (options.root) {
            context = trace.deleteSpan(context);
        }
        const parentSpan = trace.getSpan(context);
        if (isTracingSuppressed(context)) {
            diag.debug('Instrumentation suppressed, returning Noop Span');
            const nonRecordingSpan = trace.wrapSpanContext(INVALID_SPAN_CONTEXT);
            return nonRecordingSpan;
        }
        const parentSpanContext = parentSpan?.spanContext();
        const spanId = this._idGenerator.generateSpanId();
        let validParentSpanContext;
        let traceId;
        let traceState;
        if (!parentSpanContext ||
            !trace.isSpanContextValid(parentSpanContext)) {
            traceId = this._idGenerator.generateTraceId();
        }
        else {
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            validParentSpanContext = parentSpanContext;
        }
        const spanKind = options.kind ?? SpanKind.INTERNAL;
        const links = (options.links ?? []).map(link => {
            return {
                context: link.context,
                attributes: sanitizeAttributes(link.attributes),
            };
        });
        const attributes = sanitizeAttributes(options.attributes);
        const samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
        traceState = samplingResult.traceState ?? traceState;
        const traceFlags = samplingResult.decision === SamplingDecision.RECORD_AND_SAMPLED
            ? TraceFlags.SAMPLED
            : TraceFlags.NONE;
        const spanContext = { traceId, spanId, traceFlags, traceState };
        if (samplingResult.decision === SamplingDecision.NOT_RECORD) {
            diag.debug('Recording is off, propagating context in a non-recording span');
            const nonRecordingSpan = trace.wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        const initAttributes = sanitizeAttributes(Object.assign(attributes, samplingResult.attributes));
        const span = new SpanImpl({
            resource: this._resource,
            scope: this.instrumentationScope,
            context,
            spanContext,
            name,
            kind: spanKind,
            links,
            parentSpanContext: validParentSpanContext,
            attributes: initAttributes,
            startTime: options.startTime,
            spanProcessor: this._spanProcessor,
            spanLimits: this._spanLimits,
        });
        return span;
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) {
            return;
        }
        else if (arguments.length === 2) {
            fn = arg2;
        }
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        }
        else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx ?? context_api_context.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = trace.setSpan(parentContext, span);
        return context_api_context.with(contextWithSpanSet, fn, undefined, span);
    }
    getGeneralLimits() {
        return this._generalLimits;
    }
    getSpanLimits() {
        return this._spanLimits;
    }
}
;

class MultiSpanProcessor {
    _spanProcessors;
    constructor(_spanProcessors) {
        this._spanProcessors = _spanProcessors;
    }
    forceFlush() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors) {
            promises.push(spanProcessor.forceFlush());
        }
        return new Promise(resolve => {
            Promise.all(promises)
                .then(() => {
                resolve();
            })
                .catch(error => {
                globalErrorHandler(error || new Error('MultiSpanProcessor: forceFlush failed'));
                resolve();
            });
        });
    }
    onStart(span, context) {
        for (const spanProcessor of this._spanProcessors) {
            spanProcessor.onStart(span, context);
        }
    }
    onEnd(span) {
        for (const spanProcessor of this._spanProcessors) {
            spanProcessor.onEnd(span);
        }
    }
    shutdown() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors) {
            promises.push(spanProcessor.shutdown());
        }
        return new Promise((resolve, reject) => {
            Promise.all(promises).then(() => {
                resolve();
            }, reject);
        });
    }
}
;






var ForceFlushState;
(function (ForceFlushState) {
    ForceFlushState[ForceFlushState["resolved"] = 0] = "resolved";
    ForceFlushState[ForceFlushState["timeout"] = 1] = "timeout";
    ForceFlushState[ForceFlushState["error"] = 2] = "error";
    ForceFlushState[ForceFlushState["unresolved"] = 3] = "unresolved";
})(ForceFlushState || (ForceFlushState = {}));
class BasicTracerProvider {
    _config;
    _tracers = new Map();
    _resource;
    _activeSpanProcessor;
    constructor(config = {}) {
        const mergedConfig = merge({}, loadDefaultConfig(), reconfigureLimits(config));
        this._resource = mergedConfig.resource ?? defaultResource();
        this._config = Object.assign({}, mergedConfig, {
            resource: this._resource,
        });
        const spanProcessors = [];
        if (config.spanProcessors?.length) {
            spanProcessors.push(...config.spanProcessors);
        }
        this._activeSpanProcessor = new MultiSpanProcessor(spanProcessors);
    }
    getTracer(name, version, options) {
        const key = `${name}@${version || ''}:${options?.schemaUrl || ''}`;
        if (!this._tracers.has(key)) {
            this._tracers.set(key, new Tracer({ name, version, schemaUrl: options?.schemaUrl }, this._config, this._resource, this._activeSpanProcessor));
        }
        return this._tracers.get(key);
    }
    forceFlush() {
        const timeout = this._config.forceFlushTimeoutMillis;
        const promises = this._activeSpanProcessor['_spanProcessors'].map((spanProcessor) => {
            return new Promise(resolve => {
                let state;
                const timeoutInterval = setTimeout(() => {
                    resolve(new Error(`Span processor did not completed within timeout period of ${timeout} ms`));
                    state = ForceFlushState.timeout;
                }, timeout);
                spanProcessor
                    .forceFlush()
                    .then(() => {
                    clearTimeout(timeoutInterval);
                    if (state !== ForceFlushState.timeout) {
                        state = ForceFlushState.resolved;
                        resolve(state);
                    }
                })
                    .catch(error => {
                    clearTimeout(timeoutInterval);
                    state = ForceFlushState.error;
                    resolve(error);
                });
            });
        });
        return new Promise((resolve, reject) => {
            Promise.all(promises)
                .then(results => {
                const errors = results.filter(result => result !== ForceFlushState.resolved);
                if (errors.length > 0) {
                    reject(errors);
                }
                else {
                    resolve();
                }
            })
                .catch(error => reject([error]));
        });
    }
    shutdown() {
        return this._activeSpanProcessor.shutdown();
    }
}
;

class StackContextManager {
    _enabled = false;
    _currentContext = ROOT_CONTEXT;
    _bindFunction(context = ROOT_CONTEXT, target) {
        const manager = this;
        const contextWrapper = function (...args) {
            return manager.with(context, () => target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length,
        });
        return contextWrapper;
    }
    active() {
        return this._currentContext;
    }
    bind(context, target) {
        if (context === undefined) {
            context = this.active();
        }
        if (typeof target === 'function') {
            return this._bindFunction(context, target);
        }
        return target;
    }
    disable() {
        this._currentContext = ROOT_CONTEXT;
        this._enabled = false;
        return this;
    }
    enable() {
        if (this._enabled) {
            return this;
        }
        this._enabled = true;
        this._currentContext = ROOT_CONTEXT;
        return this;
    }
    with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || ROOT_CONTEXT;
        try {
            return fn.call(thisArg, ...args);
        }
        finally {
            this._currentContext = previousContext;
        }
    }
}
;
var NoopTextMapPropagator =  (function () {
    function NoopTextMapPropagator() {
    }
    NoopTextMapPropagator.prototype.inject = function (_context, _carrier) { };
    NoopTextMapPropagator.prototype.extract = function (context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function () {
        return [];
    };
    return NoopTextMapPropagator;
}());

;
var defaultTextMapGetter = {
    get: function (carrier, key) {
        if (carrier == null) {
            return undefined;
        }
        return carrier[key];
    },
    keys: function (carrier) {
        if (carrier == null) {
            return [];
        }
        return Object.keys(carrier);
    },
};
var defaultTextMapSetter = {
    set: function (carrier, key, value) {
        if (carrier == null) {
            return;
        }
        carrier[key] = value;
    },
};
;


var BAGGAGE_KEY = createContextKey('OpenTelemetry Baggage Key');
function getBaggage(context) {
    return context.getValue(BAGGAGE_KEY) || undefined;
}
function getActiveBaggage() {
    return getBaggage(ContextAPI.getInstance().active());
}
function setBaggage(context, baggage) {
    return context.setValue(BAGGAGE_KEY, baggage);
}
function deleteBaggage(context) {
    return context.deleteValue(BAGGAGE_KEY);
}
;
var baggage_impl_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var BaggageImpl =  (function () {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function (key) {
        var entry = this._entries.get(key);
        if (!entry) {
            return undefined;
        }
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function () {
        return Array.from(this._entries.entries()).map(function (_a) {
            var _b = baggage_impl_read(_a, 2), k = _b[0], v = _b[1];
            return [k, v];
        });
    };
    BaggageImpl.prototype.setEntry = function (key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function (key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function () {
        var e_1, _a;
        var keys = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            keys[_i] = arguments[_i];
        }
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function () {
        return new BaggageImpl();
    };
    return BaggageImpl;
}());

;
var baggageEntryMetadataSymbol = Symbol('BaggageEntryMetadata');
;



var utils_diag = DiagAPI.instance();
function createBaggage(entries) {
    if (entries === void 0) { entries = {}; }
    return new BaggageImpl(new Map(Object.entries(entries)));
}
function baggageEntryMetadataFromString(str) {
    if (typeof str !== 'string') {
        utils_diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: baggageEntryMetadataSymbol,
        toString: function () {
            return str;
        },
    };
}
;






var propagation_API_NAME = 'propagation';
var NOOP_TEXT_MAP_PROPAGATOR = new NoopTextMapPropagator();
var PropagationAPI =  (function () {
    function PropagationAPI() {
        this.createBaggage = createBaggage;
        this.getBaggage = getBaggage;
        this.getActiveBaggage = getActiveBaggage;
        this.setBaggage = setBaggage;
        this.deleteBaggage = deleteBaggage;
    }
    PropagationAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new PropagationAPI();
        }
        return this._instance;
    };
    PropagationAPI.prototype.setGlobalPropagator = function (propagator) {
        return registerGlobal(propagation_API_NAME, propagator, DiagAPI.instance());
    };
    PropagationAPI.prototype.inject = function (context, carrier, setter) {
        if (setter === void 0) { setter = defaultTextMapSetter; }
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    PropagationAPI.prototype.extract = function (context, carrier, getter) {
        if (getter === void 0) { getter = defaultTextMapGetter; }
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    PropagationAPI.prototype.fields = function () {
        return this._getGlobalPropagator().fields();
    };
    PropagationAPI.prototype.disable = function () {
        unregisterGlobal(propagation_API_NAME, DiagAPI.instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function () {
        return getGlobal(propagation_API_NAME) || NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}());

;

var propagation = PropagationAPI.getInstance();
;

class CompositePropagator {
    _propagators;
    _fields;
    constructor(config = {}) {
        this._propagators = config.propagators ?? [];
        this._fields = Array.from(new Set(this._propagators
            .map(p => (typeof p.fields === 'function' ? p.fields() : []))
            .reduce((x, y) => x.concat(y), [])));
    }
    inject(context, carrier, setter) {
        for (const propagator of this._propagators) {
            try {
                propagator.inject(context, carrier, setter);
            }
            catch (err) {
                diag.warn(`Failed to inject with ${propagator.constructor.name}. Err: ${err.message}`);
            }
        }
    }
    extract(context, carrier, getter) {
        return this._propagators.reduce((ctx, propagator) => {
            try {
                return propagator.extract(ctx, carrier, getter);
            }
            catch (err) {
                diag.warn(`Failed to extract with ${propagator.constructor.name}. Err: ${err.message}`);
            }
            return ctx;
        }, context);
    }
    fields() {
        return this._fields.slice();
    }
}
;
const VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
const VALID_KEY = `[a-z]${VALID_KEY_CHAR_RANGE}{0,255}`;
const VALID_VENDOR_KEY = `[a-z0-9]${VALID_KEY_CHAR_RANGE}{0,240}@[a-z]${VALID_KEY_CHAR_RANGE}{0,13}`;
const VALID_KEY_REGEX = new RegExp(`^(?:${VALID_KEY}|${VALID_VENDOR_KEY})$`);
const VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
const INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function validateKey(key) {
    return VALID_KEY_REGEX.test(key);
}
function validateValue(value) {
    return (VALID_VALUE_BASE_REGEX.test(value) &&
        !INVALID_VALUE_COMMA_EQUAL_REGEX.test(value));
}
;

const MAX_TRACE_STATE_ITEMS = 32;
const MAX_TRACE_STATE_LEN = 512;
const LIST_MEMBERS_SEPARATOR = ',';
const LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
class TraceState {
    _internalState = new Map();
    constructor(rawTraceState) {
        if (rawTraceState)
            this._parse(rawTraceState);
    }
    set(key, value) {
        const traceState = this._clone();
        if (traceState._internalState.has(key)) {
            traceState._internalState.delete(key);
        }
        traceState._internalState.set(key, value);
        return traceState;
    }
    unset(key) {
        const traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    }
    get(key) {
        return this._internalState.get(key);
    }
    serialize() {
        return this._keys()
            .reduce((agg, key) => {
            agg.push(key + LIST_MEMBER_KEY_VALUE_SPLITTER + this.get(key));
            return agg;
        }, [])
            .join(LIST_MEMBERS_SEPARATOR);
    }
    _parse(rawTraceState) {
        if (rawTraceState.length > MAX_TRACE_STATE_LEN)
            return;
        this._internalState = rawTraceState
            .split(LIST_MEMBERS_SEPARATOR)
            .reverse() 
            .reduce((agg, part) => {
            const listMember = part.trim(); 
            const i = listMember.indexOf(LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                const key = listMember.slice(0, i);
                const value = listMember.slice(i + 1, part.length);
                if (validateKey(key) && validateValue(value)) {
                    agg.set(key, value);
                }
                else {
                }
            }
            return agg;
        }, new Map());
        if (this._internalState.size > MAX_TRACE_STATE_ITEMS) {
            this._internalState = new Map(Array.from(this._internalState.entries())
                .reverse() 
                .slice(0, MAX_TRACE_STATE_ITEMS));
        }
    }
    _keys() {
        return Array.from(this._internalState.keys()).reverse();
    }
    _clone() {
        const traceState = new TraceState();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    }
}
;



const TRACE_PARENT_HEADER = 'traceparent';
const TRACE_STATE_HEADER = 'tracestate';
const W3CTraceContextPropagator_VERSION = '00';
const VERSION_PART = '(?!ff)[\\da-f]{2}';
const TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
const PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
const FLAGS_PART = '[\\da-f]{2}';
const TRACE_PARENT_REGEX = new RegExp(`^\\s?(${VERSION_PART})-(${TRACE_ID_PART})-(${PARENT_ID_PART})-(${FLAGS_PART})(-.*)?\\s?$`);
function parseTraceParent(traceParent) {
    const match = TRACE_PARENT_REGEX.exec(traceParent);
    if (!match)
        return null;
    if (match[1] === '00' && match[5])
        return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16),
    };
}
class W3CTraceContextPropagator {
    inject(context, carrier, setter) {
        const spanContext = trace.getSpanContext(context);
        if (!spanContext ||
            isTracingSuppressed(context) ||
            !isSpanContextValid(spanContext))
            return;
        const traceParent = `${W3CTraceContextPropagator_VERSION}-${spanContext.traceId}-${spanContext.spanId}-0${Number(spanContext.traceFlags || TraceFlags.NONE).toString(16)}`;
        setter.set(carrier, TRACE_PARENT_HEADER, traceParent);
        if (spanContext.traceState) {
            setter.set(carrier, TRACE_STATE_HEADER, spanContext.traceState.serialize());
        }
    }
    extract(context, carrier, getter) {
        const traceParentHeader = getter.get(carrier, TRACE_PARENT_HEADER);
        if (!traceParentHeader)
            return context;
        const traceParent = Array.isArray(traceParentHeader)
            ? traceParentHeader[0]
            : traceParentHeader;
        if (typeof traceParent !== 'string')
            return context;
        const spanContext = parseTraceParent(traceParent);
        if (!spanContext)
            return context;
        spanContext.isRemote = true;
        const traceStateHeader = getter.get(carrier, TRACE_STATE_HEADER);
        if (traceStateHeader) {
            const state = Array.isArray(traceStateHeader)
                ? traceStateHeader.join(',')
                : traceStateHeader;
            spanContext.traceState = new TraceState(typeof state === 'string' ? state : undefined);
        }
        return trace.setSpanContext(context, spanContext);
    }
    fields() {
        return [TRACE_PARENT_HEADER, TRACE_STATE_HEADER];
    }
}
;
const BAGGAGE_KEY_PAIR_SEPARATOR = '=';
const BAGGAGE_PROPERTIES_SEPARATOR = ';';
const constants_BAGGAGE_ITEMS_SEPARATOR = ',';
const BAGGAGE_HEADER = 'baggage';
const BAGGAGE_MAX_NAME_VALUE_PAIRS = 180;
const BAGGAGE_MAX_PER_NAME_VALUE_PAIRS = 4096;
const BAGGAGE_MAX_TOTAL_LENGTH = 8192;
;


function serializeKeyPairs(keyPairs) {
    return keyPairs.reduce((hValue, current) => {
        const value = `${hValue}${hValue !== '' ? constants_BAGGAGE_ITEMS_SEPARATOR : ''}${current}`;
        return value.length > BAGGAGE_MAX_TOTAL_LENGTH ? hValue : value;
    }, '');
}
function getKeyPairs(baggage) {
    return baggage.getAllEntries().map(([key, value]) => {
        let entry = `${encodeURIComponent(key)}=${encodeURIComponent(value.value)}`;
        if (value.metadata !== undefined) {
            entry += BAGGAGE_PROPERTIES_SEPARATOR + value.metadata.toString();
        }
        return entry;
    });
}
function parsePairKeyValue(entry) {
    const valueProps = entry.split(BAGGAGE_PROPERTIES_SEPARATOR);
    if (valueProps.length <= 0)
        return;
    const keyPairPart = valueProps.shift();
    if (!keyPairPart)
        return;
    const separatorIndex = keyPairPart.indexOf(BAGGAGE_KEY_PAIR_SEPARATOR);
    if (separatorIndex <= 0)
        return;
    const key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    const value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    let metadata;
    if (valueProps.length > 0) {
        metadata = baggageEntryMetadataFromString(valueProps.join(BAGGAGE_PROPERTIES_SEPARATOR));
    }
    return { key, value, metadata };
}
function parseKeyPairsIntoRecord(value) {
    if (typeof value !== 'string' || value.length === 0)
        return {};
    return value
        .split(BAGGAGE_ITEMS_SEPARATOR)
        .map(entry => {
        return parsePairKeyValue(entry);
    })
        .filter(keyPair => keyPair !== undefined && keyPair.value.length > 0)
        .reduce((headers, keyPair) => {
        headers[keyPair.key] = keyPair.value;
        return headers;
    }, {});
}
;




class W3CBaggagePropagator {
    inject(context, carrier, setter) {
        const baggage = propagation.getBaggage(context);
        if (!baggage || isTracingSuppressed(context))
            return;
        const keyPairs = getKeyPairs(baggage)
            .filter((pair) => {
            return pair.length <= BAGGAGE_MAX_PER_NAME_VALUE_PAIRS;
        })
            .slice(0, BAGGAGE_MAX_NAME_VALUE_PAIRS);
        const headerValue = serializeKeyPairs(keyPairs);
        if (headerValue.length > 0) {
            setter.set(carrier, BAGGAGE_HEADER, headerValue);
        }
    }
    extract(context, carrier, getter) {
        const headerValue = getter.get(carrier, BAGGAGE_HEADER);
        const baggageString = Array.isArray(headerValue)
            ? headerValue.join(constants_BAGGAGE_ITEMS_SEPARATOR)
            : headerValue;
        if (!baggageString)
            return context;
        const baggage = {};
        if (baggageString.length === 0) {
            return context;
        }
        const pairs = baggageString.split(constants_BAGGAGE_ITEMS_SEPARATOR);
        pairs.forEach(entry => {
            const keyPair = parsePairKeyValue(entry);
            if (keyPair) {
                const baggageEntry = { value: keyPair.value };
                if (keyPair.metadata) {
                    baggageEntry.metadata = keyPair.metadata;
                }
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) {
            return context;
        }
        return propagation.setBaggage(context, propagation.createBaggage(baggage));
    }
    fields() {
        return [BAGGAGE_HEADER];
    }
}
;




function setupContextManager(contextManager) {
    if (contextManager === null) {
        return;
    }
    if (contextManager === undefined) {
        const defaultContextManager = new StackContextManager();
        defaultContextManager.enable();
        context_api_context.setGlobalContextManager(defaultContextManager);
        return;
    }
    contextManager.enable();
    context_api_context.setGlobalContextManager(contextManager);
}
function setupPropagator(propagator) {
    if (propagator === null) {
        return;
    }
    if (propagator === undefined) {
        propagation.setGlobalPropagator(new CompositePropagator({
            propagators: [
                new W3CTraceContextPropagator(),
                new W3CBaggagePropagator(),
            ],
        }));
        return;
    }
    propagation.setGlobalPropagator(propagator);
}
class WebTracerProvider extends BasicTracerProvider {
    constructor(config = {}) {
        super(config);
    }
    register(config = {}) {
        trace.setGlobalTracerProvider(this);
        setupPropagator(config.propagator);
        setupContextManager(config.contextManager);
    }
}
;



window.OpenTelemetry = window.OpenTelemetry || {};
window.OpenTelemetry.sdkTraceWeb = window.OpenTelemetry.sdkTraceWeb || { WebTracerProvider: WebTracerProvider };

 	return __webpack_exports__;
 })()
;
});

 })(window);